// https://minify-js.com/
import { $4, $$4, $id4, isRTL, formatMoney, debounce, getterAdd, getterGet, getterRunFn, btnTooltip, Drawer, VariantChangeBase } from "@theme/global";
// WISHLIST
var $wishlist_list = $id4('hdt_wishlist_list'),
  $compare_list = $id4('hdt_compare_list'),
  nameCachedWishlist = 'theme4:wishlist:id',
  nameCachedCompare = 'theme4:compare:id';
// if exit $wishlist_list is use app wishlist the4
if ($wishlist_list) {
  var arr_wishlist_list = $wishlist_list.textContent ? $wishlist_list.textContent.split(' ') : [];
}
else {
  var arr_wishlist_list = (!localStorage.getItem(nameCachedWishlist)) ? [] : localStorage.getItem(nameCachedWishlist).split(',');  // remove id: and conver array
}
if ($compare_list){
  var arr_compare_list = $compare_list.textContent ? $compare_list.textContent.split(' ') : [];
}
else {
  var arr_compare_list = (!localStorage.getItem(nameCachedCompare)) ? [] : localStorage.getItem(nameCachedCompare).split(',');  // remove id: and conver array
}
// arr_wishlist_list = [1234, 5678, 9011]
// arr_compare_list = [1234, 5678, 9011]

var linkWishlistApp = '/apps/ecomrise/wishlist',
  linkCompareApp = '/apps/ecomrise/compare',
  //actionAfterWishlistAdded = themeHDN.extras.AddedWishlistRemove ? 'remove' : 'added',
  //actionAfterCompareAdded = themeHDN.extras.AddedCompareRemove ? 'remove' : 'added',
  limitWishlist = $wishlist_list ? 100 : 50,
  limitCompare = 6,
  conver_to_link_fn = function (prefix = this.textFn, array = this.array) {
    const x = themeHDN.routes.search_url + `/?view=${prefix}`,
      y = x + '&type=product&options[unavailable_products]=last&q=';
    return (array.length) ? y + encodeURI(`id:${array.join(' OR id:')}`) : x;
  };
// Reset if limit change
if (arr_wishlist_list.length > limitWishlist) {
  arr_wishlist_list.splice(limitWishlist - 1, arr_wishlist_list.length - 1);
  localStorage.setItem(nameCachedWishlist, arr_wishlist_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageWishlist) {
  if (arr_wishlist_list.length && !window.isWishlistPerformed) {
    window.location.href = conver_to_link_fn('wishlist', arr_wishlist_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('wishlist', []));
  }
  themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
}

// Reset if limit change
if (arr_compare_list.length > limitCompare) {
  arr_compare_list.splice(limitCompare - 1, arr_compare_list.length - 1);
  localStorage.setItem(nameCachedCompare, arr_compare_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageCompare) {
  if (arr_compare_list.length && !window.isComparePerformed) {
    window.location.href = conver_to_link_fn('compare', arr_compare_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('compare', []));
  }
}
var _wishlist_id, _wishlist_handle,
  _update_wis_text, update_wis_text_fn,
  _update_wis_btns, update_wis_btns_fn,
  _click_wis, click_wis_fn,
  _add_wis, add_wis_fn,
  _remove_wis, remove_wis_fn,
  _action_after_remove_add, action_after_remove_add_fn,
  _show_popup_compare, show_popup_compare_fn,
  _conver_to_link;
class Wishlist extends btnTooltip {
  constructor() {
    super();
    getterAdd(_wishlist_id, this, this.dataset.id);
    getterAdd(_wishlist_handle, this, this.dataset.handle);
    getterAdd(_update_wis_text, this);
    getterAdd(_update_wis_btns, this);
    getterAdd(_click_wis, this);
    getterAdd(_add_wis, this);
    getterAdd(_remove_wis, this);
    getterAdd(_action_after_remove_add, this);
    getterAdd(_show_popup_compare, this);
    getterAdd(_conver_to_link, this);
    this.tabIndex = 0;
    this.addEventListener("click", () => getterRunFn(_click_wis, this, click_wis_fn).call(this));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_click_wis, this, click_wis_fn).call(this)
    });
  }
  static get observedAttributes() {
    return ["action"];
  }
  get isFnWishlist() {
    return true;
  }
  get textFn() {
    return 'wishlist';
  }
  get isPageWishlistorCompare() {
    //add code check page
    return this.isFnWishlist ? window.isPageWishlist : window.isPageCompare;
  }
  get limit() {
    return this.isFnWishlist ? limitWishlist : limitCompare;
  }
  get nameCached() {
    return this.isFnWishlist ? nameCachedWishlist : nameCachedCompare;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  // get actionAfterAdded() {
  //   return this.isFnWishlist ? actionAfterWishlistAdded : actionAfterCompareAdded;
  // }
  get action() {
    return this.getAttribute('action');
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || (oldValue === null && newValue === 'add')) return;
    getterRunFn(_update_wis_text, this, update_wis_text_fn).call(this, newValue);
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.array.indexOf(getterGet(_wishlist_id, this)) > -1) {
      if (this.hasAttribute('remove-on-page')) {
        return
      }
      this.setAttribute('action', this.actionAfterAdded);
    }
  }
};
_wishlist_id = new WeakMap();
_wishlist_handle = new WeakMap();
_update_wis_text = new WeakSet();
_update_wis_btns = new WeakSet();
_click_wis = new WeakSet();
_add_wis = new WeakSet();
_remove_wis = new WeakSet();
_action_after_remove_add = new WeakSet();
_conver_to_link = new WeakSet();
_show_popup_compare = new WeakSet();
update_wis_text_fn = function (value) {
  if (this.hasAttribute('remove-on-page')) return;
  const text = themeHDN.extras[`text_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`],
    icon = themeHDN.extras[`icon_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`];
  if (icon) this.firstElementChild.replaceWith(document.createRange().createContextualFragment(icon));
  if (text) {
    this.lastElementChild.textContent = text;
    this.setAttribute('data-txt-tt',text)
  }
};
update_wis_btns_fn = function (_action) {
  // Update Button
  $$4(`hdt-${this.textFn}[data-id="${getterGet(_wishlist_id, this)}"]`).forEach(btn => {
    btn.setAttribute('action', _action);
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.textFn}:update`, {
    bubbles: true,
    detail: 'the4'  // arr_wishlist_list
  }));
  if ((window.isPageWishlist)) themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
};
click_wis_fn = function (e) {
  if (this.action == 'add') {
    // ADD
    getterRunFn(_add_wis, this, add_wis_fn).call(this);
  } else if (this.action === 'added') {
    // ADDED: go to page wishlist
    if (!this.isFnWishlist && themeHDN.extras.enableComparePopup) {
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    } else {
      window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
  } else {
    // REMOVE
    getterRunFn(_remove_wis, this, remove_wis_fn).call(this);
  }
};
add_wis_fn = function (e) {
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      if(this.isFnWishlist) {
        arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_wishlist_list)) {
          arr_wishlist_list = arr_wishlist_list.split(',');
        }
      }
      if (!this.isFnWishlist) {
        arr_compare_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_compare_list)) {
          arr_compare_list = arr_compare_list.split(',');
        }
        getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  }
  else {
    // local wishlist
    // adds the specified elements to the beginning of an array
    this.array.unshift(getterGet(_wishlist_id, this));
    //console.log(this.array, getterGet(_wishlist_id, this))
    if (this.array.length > this.limit) {
      // if over limit remove element on last array
      let arraySplice = this.array.splice(this.limit, 1);
      // arraySplice: allway has 1 element
      $$4(`hdt-${this.textFn}[data-id="${arraySplice[0]}"]`).forEach(btn => {
        btn.setAttribute('action', 'add');
      });
    }
    if (!this.isFnWishlist) getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    localStorage.setItem(this.nameCached, this.array.toString());
  }
};
remove_wis_fn = function (e) {
  // REMOVE
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add',
        _method: 'DELETE'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
      if (!Array.isArray(arr_wishlist_list)) {
        arr_wishlist_list = arr_wishlist_list.split(',');
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  } else {
    // local wishlist
    this.array.splice(this.array.indexOf(getterGet(_wishlist_id, this)), 1);
    localStorage.setItem(this.nameCached, this.array.toString());

    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
  }
};
action_after_remove_add_fn = function (action) {

  if (this.getAttribute('action') == 'remove' && this.hasAttribute('remove-on-page')) {
    if (this.isFnWishlist) {
      this.closest('.hdt-card-product').remove();
    } else {
      $$4(`.hdt-compare-item-${getterGet(_wishlist_id, this)}`).forEach(item => {
        item.remove();
      });
    }
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    if (this.array.length == 0) {
      $id4(`drawerCompare`)?.removeAttribute('open');
      if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
    //this.setAttribute('action', action);
  } else {
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    // is page wishlist or compare reload page
    if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
  }
};
show_popup_compare_fn = function (event) {
  if (!themeHDN.extras.enableComparePopup || this.isPageWishlistorCompare) return;
  // add code if want show popup compare
  $$4('hdt-tooltip-dialog').forEach((tooltip)=> {
    tooltip.setAttribute('hidden', '');
  }); // Fix https://github.com/The4-Theme-Dev/Ecomus/issues/81
  $id4(`drawerCompare`).setAttribute('open', '');
  fetch(conver_to_link_fn('compare', arr_compare_list) + "&section_id=compare-offcanvas")
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const prds = html.querySelector('offcanvas-compare');

      if (prds && prds.innerHTML.trim().length) {

        $4("offcanvas-compare").innerHTML = prds.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};
var _clear_all, clear_all_fn;
class ClearAll extends HTMLElement {
  constructor() {
    super();
    getterAdd(_clear_all, this);
    this.tabIndex = 0;
    this.addEventListener("click", getterRunFn(_clear_all, this, clear_all_fn));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_clear_all, this, clear_all_fn).call(this)
    });
  }
  get ofFn() {
    return this.getAttribute('of-fn'); //'compare', 'wishlist'
  }
  get nameCached() {
    return this.ofFn == 'compare' ? nameCachedCompare : nameCachedWishlist;
  }
  set array(value) {
    this.ofFn == 'compare' ? arr_compare_list = value : arr_wishlist_list = value;
  }
};
_clear_all = new WeakSet();
clear_all_fn = function () {
  localStorage.removeItem(this.nameCached);
  // Update Buttons
  $$4(`hdt-${this.ofFn}[action="added"]`).forEach(btn => {
    btn.setAttribute('action', 'add');
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.ofFn}:update`, {
    bubbles: true,
    detail: 'the4'
  }));
  this.array = [];
  $id4(`drawerCompare`)?.removeAttribute('open');
  if ($4(`#drawerCompare offcanvas-compare`)){
    $4(`#drawerCompare offcanvas-compare`).innerHTML = "";
  }
};
customElements.define("hdt-clear-all", ClearAll);
// eg: <hdt-clear-all role="button" of-fn="compare">Clear All </hdt-clear-all>

// Update count
class WishlistCount extends HTMLElement {
  constructor() {
    super();
    this.textContent = this.array.length;
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      //console.log(this.prefix + ' count update.');
      this.textContent = this.array.length;
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
// Update link page
class WishlistLink extends HTMLElement {
  constructor() {
    super();
    $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    //console.log('WishlistLink', this.href)
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
customElements.define("hdt-wishlist", Wishlist);
customElements.define("hdt-wishlist-count", WishlistCount);
customElements.define("hdt-wishlist-a", WishlistLink);

// COMPARE
class Compare extends Wishlist {
  get isFnWishlist() {
    return false;
  }
  get textFn() {
    return 'compare';
  }
}
// Update count
class CompareCount extends WishlistCount {
  get isFnWishlist() {
    return false;
  }
}
// Update link page
class CompareLink extends WishlistLink {
  get isFnWishlist() {
    return false;
  }
}
customElements.define("hdt-compare", Compare);
customElements.define("hdt-compare-count", CompareCount);
customElements.define("hdt-compare-a", CompareLink);

// --------------------------
// Product Recommendations
// --------------------------
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          document.dispatchEvent(new CustomEvent("currency:update"));
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// --------------------------
// Product Recently
// --------------------------
class ProductRecently extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let handleProducts = localStorage.getItem("theme4:recently:id");
      let prdId = this.dataset.id;

      if (handleProducts !== null) {
        let products = handleProducts.split(',');
        let url = this.dataset.url.replace('q=', 'q=id:' + products.join("%20OR%20id:"));
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recently = html.querySelector('product-recently');

            if (recently && recently.innerHTML.trim().length) {
              this.innerHTML = recently.innerHTML;
            }
            document.dispatchEvent(new CustomEvent("currency:update"));
          })
          .catch((e) => {
            console.error(e);
          });

      }
      let arrayProducts = handleProducts !== null ? handleProducts.split(',') : new Array;
      if (!arrayProducts.includes(prdId + '')) {
        if (arrayProducts.length >= 10) {
          arrayProducts.pop();
        }
        function prepend(value, array) {
          var newArray = array.slice();
          newArray.unshift(value);
          return newArray;
        }
        arrayProducts = prepend(prdId, arrayProducts);
        arrayProducts = arrayProducts.toString();
        localStorage.setItem("theme4:recently:id", arrayProducts);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recently', ProductRecently);


// --------------------------
// Predictive Search
// --------------------------
class PredictiveSearch extends Drawer {
  constructor() {
    super();
    // console.log(!this.hasAttribute('enabled'))
    if (!this.hasAttribute('enabled')) return;
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-results-search]');
    this.input = this.querySelector('input[type="search"]');
    this.sectionIdResults = this.getAttribute('data-section-id-results') || 'hdt_predictive-search';
    this.allPredictiveSearchInstances = $$4('predictive-search');
    this.skeleton = this.querySelector('[data-skeleton-search]');
    this.noResults = this.querySelector('.hdt-cart-no-results');
    this.hideWrapper = this.querySelector('.hdt-cart-hide-has-results');
    this.showWrapper = this.querySelector('.hdt-cart-show-has-results');
    this.btn_viewall = this.querySelector('.hdt-view_all');
    this.href = this.btn_viewall?.getAttribute("href");
    this.isOpen = false;
    this.abortController2 = new AbortController();
    this.searchTerm = '';
    if (this.input) {
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    const formData = new FormData(this.input.form);
    this.params = "";
    for (const [key, value] of formData) {
      if (key === 'q') break;
      this.params += `${key}=${value}&`;
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    this.btn_viewall?.setAttribute("href", this.href.replace(/\/search\?q=.*/g, "/search?q=" + this.searchTerm));

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.openSearch();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    // switch (event.code) {
    //   case 'ArrowUp':
    //     this.switchOption('up');
    //     break;
    //   case 'ArrowDown':
    //     this.switchOption('down');
    //     break;
    //   case 'Enter':
    //     this.selectOption();
    //     break;
    // }
  }

  // onKeydown(event) {
  //   // Prevent the cursor from moving in the input when using the up and down arrow keys
  //   if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
  //     event.preventDefault();
  //   }
  // }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${themeHDN.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${this.params}section_id=${this.sectionIdResults}`, {
      signal: this.abortController2.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-' + this.sectionIdResults).innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          this.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.hideWrapper.style.cssText = "display: none;";
    this.showWrapper.style.cssText = "display: block;";
    this.skeleton.classList.remove("hdt-hidden");

    this.setAttribute('loading', true);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.openSearch();
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
  }

  openSearch() {
    //this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.skeleton.classList.add("hdt-hidden");
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.hideWrapper.style.cssText = "display: block;";
      this.showWrapper.style.cssText = "display: none;";
      this.predictiveSearchResults.innerHTML = "";
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    //this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('hdt-predictive-search', PredictiveSearch);
// bundle product

const bundleProduct = () => {
  if (window.innerWidth < 768) {
    return;
  }
  let arrBundle = $$4("[data-bundle-pin]");
  if (!arrBundle) {
    return;
  }
  arrBundle.forEach((el) => {
    if (!el.dataset.trigger) {
      return;
    } else {
      el.onmouseover = () => {
        $4(el.dataset.trigger).classList.add("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.add("has--hover");
      };
      el.onmouseleave = () => {
        $4(el.dataset.trigger).classList.remove("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.remove("has--hover");
      };
    }
  });
};
bundleProduct();

// --------------------------
// Back to top
// --------------------------
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (window.innerWidth < 768 && this.config.hiddenMobile) return;
    this.debounce_timer = 0;
    this.debounce_timer2 = 0;
    this.circlechart = this.querySelector('.hdt-circle-css');
    this.addEventListener("click", this.goTop.bind(this));
    window.addEventListener("scroll", this.backToTop.bind(this));
  }
  goTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  backToTop() {
    let self = this;
    if (this.debounce_timer) { clearTimeout(this.debounce_timer); }
    this.debounce_timer = setTimeout(function () {
      if (window.scrollY > self.config.scrollTop) {
        self.classList.add('is--show');
      } else {
        self.classList.remove('is--show');
      }
    }, 40);

    if (!this.circlechart) return;

    if (this.debounce_timer2) { clearTimeout(this.debounce_timer2); }

    this.debounce_timer2 = setTimeout(function () {
      let scrollTop2 = window.scrollY,
        docHeight = document.body.offsetHeight,
        winHeight = window.innerHeight,
        scrollPercent = scrollTop2 / (docHeight - winHeight),
        degrees = scrollPercent * 360;
      self.circlechart.style.setProperty("--cricle-degrees", degrees + 'deg');
    }, 6);
  }
}

customElements.define('back-to-top', BackToTop);


// --------------------------
// numberRandom
// --------------------------
class numberRandom extends HTMLElement {
  constructor() {
    super();
    let config = JSON.parse(this.getAttribute("config"));
    this.min = config.min;
    this.max = config.max;
    this.interval = config.interval;
    this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    this.ofset = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"];
    this.prioritize = ["10", "20", "15"];
    this.h = "";
    this.e = "";
    this.M = "";
    this.liveViewInt();
    setInterval(this.liveViewInt.bind(this), this.interval);
  }

  liveViewInt() {
    if (this.h = Math.floor(Math.random() * this.ofset.length), this.e = this.ofset[this.h], this.number = parseInt(this.number) + parseInt(this.e), this.min >= this.number) {
      this.M = Math.floor(Math.random() * this.prioritize.length);
      var a = this.prioritize[this.M];
      this.number += a
    }
    if (this.number < this.min || this.number > this.max) {
      this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    }
    this.innerHTML = parseInt(this.number);
  }
}

customElements.define('number-random', numberRandom);

// --------------------------
// Lookbook product carousel
// --------------------------

class LookbookProductCarousel extends HTMLElement {

  constructor() {
    super();
    if (window.innerWidth > 767) {
      return;
    }
    this.lookbookMobile();
  }
  lookbookMobile() {
    let self = this;
    const el = self.querySelector('[lookbook-product-wrap]');
    const controls = self.querySelector('[hdt-slider-controls]');
    const btn_close = self.querySelector('button.hdt-close');
    const isToolBar = document.querySelector('.hdt-toolbar-mobile');
    let toolBarH = 0;
    if (!el | !controls | !btn_close) return;
    if (isToolBar) {
      toolBarH += isToolBar.offsetHeight;
    }

    self.querySelector('[lookbook-product-wrap]').style.bottom = `${toolBarH / 10}rem`;
    controls.addEventListener('click', () => {
      el.classList.add('hdt-open');
    })
    btn_close.addEventListener('click', () => {
      el.classList.remove('hdt-open');
    })
  }
}
customElements.define('lookbook-product-carousel', LookbookProductCarousel);

/**
  * Cookies
  * https://help.shopify.com/en/manual/your-account/privacy/cookies
  * https://shopify.dev/themes/trust-security/cookie-banner#create-a-snippet-to-host-the-banner
  * https://help.shopify.com/en/manual/your-account/privacy/privacy-preferences-manager?shpxid=965d0d2a-08E2-4654-4A13-D3F38646AC5D
  * https://shopify.dev/api/consent-tracking
*/

function convertNameCookies(name) {
  return name.replace(/=/g,'_');
}
function setCookie(name,value,days,hours) {
  var expires = "";
  if (days || hours) {
    var date = new Date();
    date.setTime(date.getTime() + (days ? days*24*60*60*1000 : hours*60*60*1000));
    expires = "; expires=" + date.toString();
  }
  document.cookie = convertNameCookies(name) + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = convertNameCookies(name) + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = convertNameCookies(name)+'=; Max-Age=-99999999;';
}

class cookiesBar extends HTMLElement {
  constructor() {
    super();
    this.cookies = JSON.parse(this.getAttribute("configs"));
    this.cookies.cookiesName = "theme4:cookies";
    this.cookies.drawer = this.querySelector("#drawerCookies");
    this.isShowCookiesAll = (this.cookies.show == '1');
    this.acceptBtn = this.cookies.drawer.querySelector(".hdt-pp_cookies__accept-btn");
    this.declineBtn = this.cookies.drawer.querySelector(".hdt-pp_cookies__decline-btn");
    this.loadCookieBanner(this);
    let self = this;
    this.acceptBtn?.addEventListener("click", this.handleAccept.bind(this));
    this.declineBtn?.addEventListener("click", this.handleDecline.bind(this));
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        const cookiesSelect = event.target.classList.contains('sys-cookies');
        if (!cookiesSelect) return;
        self.showCookiesBanner();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const cookiesSelect = event.target.classList.contains('sys-cookies');
        if (!cookiesSelect) return;
        self.hideCookiesBanner();
      })
    }
  }
  handleAccept() {
    if (this.isShowCookiesAll) {
      setCookie(this.cookies.cookiesName, 'accepted', parseInt(this.cookies.day_next));
    }
    window.Shopify.customerPrivacy.setTrackingConsent(true, this.hideCookiesBanner.bind(this));
  }

  handleDecline() {
    if (this.isShowCookiesAll) {
      setCookie(this.cookies.cookiesName, 'accepted', parseInt(this.cookies.day_next));
    }
    window.Shopify.customerPrivacy.setTrackingConsent(false, this.hideCookiesBanner.bind(this));
  }

  showCookiesBanner() {
    this.cookies.drawer.setAttribute('open', '');
    $4("html").classList.remove("no-scroll");
  }

  hideCookiesBanner() {
    this.cookies.drawer.removeAttribute('open');
  }

  initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if ((!userCanBeTracked && userTrackingConsent === 'no_interaction') || this.isShowCookiesAll) {
      if (!Shopify.designMode) {
        this.showCookiesBanner();
      }
    }
  }

  loadCookieBanner() {

    let self = this;
    if (this.cookies.drawer.length == 0) return;
    this.cookies.day_next = this.cookies.day_next || 60;
    this.isShowCookiesAll = (this.cookies.show == '1');
    if (getCookie(this.cookies.cookiesName) == 'accepted' || this.cookies.drawer.getAttribute("open") !== null) return;

    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1',
      }
    ],
      function (error) {
        if (error) {
          throw error;
        }
        self.initCookieBanner();
      });
  }
}

customElements.define('sys-cookies', cookiesBar);

// --------------------------
// Newsletter
// --------------------------

class newsletterModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute('configs'));
    if ( !Shopify.designMode && getCookie("theme4:newsletter:"+this.configs.id) == 'shown' ) return;
    this.modal = this.querySelector("#modalNewsletter-"+this.configs.id);
    this.action_close = this.querySelector('[action-close]');
    this.time_delay     = this.configs.time_delay;
    this.day_next       = this.configs.day_next;
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        const newsletterSelect = event.target.classList.contains('sys-newsletter');
        if (!newsletterSelect) return;
        this.modal.setAttribute('open', '');
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const newsletterSelect = event.target.classList.contains('sys-newsletter');
        if (!newsletterSelect) return;
        this.modal.removeAttribute('open');
      })
    }
    else {
      const fnShow = this.showModal.bind(this);
      const fnShowScroll = this.showModalScroll.bind(this);
      if(this.configs.after === 'time'){
        let tm = setTimeout(fnShow,this.configs.time_delay * 1000);
        this.modal.addEventListener("dialog:afterClose", () => {
          clearTimeout(tm);
          this.hideModal(false, true);
        });
      }else{
        window.addEventListener("scroll",fnShowScroll);
        this.modal.addEventListener("dialog:afterClose", () => {
          window.removeEventListener("scroll", fnShowScroll);
          this.hideModal(false, true);
        });
      }
      this.actionClose();
    }
  }

  showModal() {
    this.modal.setAttribute('open', '');
  }
  showModalScroll(){
    if (window.scrollY > this.configs.scroll_delay) {
      this.modal.setAttribute('open', '');
    }
  }
  hideModal(pause, off) {
    if (pause) {

    }
    if (off) {

      setCookie("theme4:newsletter:"+this.configs.id, "shown", this.day_next);
    }
  }
  actionClose(){
    let self= this;
    if(self.action_close){
      self.action_close.addEventListener('click',function(){
        self.modal.removeAttribute('open', '');
        self.hideModal(false, true);
      })
    }
  }

}
customElements.define('sys-newsletter', newsletterModal);

// --------------------------
// Exit
// --------------------------

class exitModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute('configs'));
    if ( !Shopify.designMode && getCookie("theme4:exit:"+this.configs.id) == 'shown' ) return;
    this.modal = this.querySelector("#modalExit-"+this.configs.id);
    this.day_next     = this.configs.day_next;
    this.btn_copy = this.querySelector('button[is="discount_copy"]');
    this.discount = this.querySelector('[is="discount"]');
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        const exitSelect = event.target.classList.contains('sys-exit');
        if (!exitSelect) return;
        this.showModal();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const exitSelect = event.target.classList.contains('sys-exit');
        if (!exitSelect) return;
        this.modal.removeAttribute('open');
      })
    }
    else {
      if(this.configs.after === 'move_cursor'){
        if(window.innerWidth > 1150){
          this.moveCursor();
        }else{
          this.scrollPage();;
        }
      }else if(this.configs.after === 'scroll'){
        this.scrollPage();
        console.log();
      }
      else{
        this.amountTime();
      }
    }
  }
  // Move cursor out screen
  moveCursor(){
    const fnShow = this.showModal.bind(this);
    document.querySelector("body").addEventListener("mouseleave", fnShow);
    this.modal.addEventListener("dialog:afterClose", () => {
      document.querySelector("body").removeEventListener("mouseleave", fnShow);
      this.hideModal(false, true);
    });
  }
  //  scroll page
  scrollPage(){
    const fnShow = this.showModal.bind(this);
    let docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight - 500;
    let scroll= ()=>{
      if (window.scrollY >= docHeight) {
        fnShow();
      }
    }
    window.addEventListener("scroll",scroll);
    this.modal.addEventListener("dialog:afterClose", () => {
      window.removeEventListener("scroll",scroll);
      this.hideModal(false, true);
    });
  }
  // countdown time to show exit popup
  amountTime(){
    const fnShow = this.showModal.bind(this);
    let tm = setTimeout(fnShow,this.configs.time_delay * 1000);
    this.modal.addEventListener("dialog:afterClose", () => {
      clearTimeout(tm);
      this.hideModal(false, true);
    });
  }
  showModal() {
    let self = this;
    this.modal.setAttribute('open', '');
    if(self.btn_copy && self.discount){
      self.btn_copy.addEventListener('click',function(){
        self.discount.select();
        self.discount.setSelectionRange(0, 99999);
        document.execCommand("copy");
        self.btn_copy.querySelector('.hdt-tooltip-text').innerText = `${themeHDN.extras.exit_popup.copied}: ${self.discount.value}`
      })
      self.btn_copy.addEventListener('mouseleave',function(){
        self.btn_copy.querySelector('.hdt-tooltip-text').innerText = themeHDN.extras.exit_popup.copy
      })
    }
  }
  hideModal(pause, off) {
    if (pause) {

    }
    if (off) {
      setCookie("theme4:exit:"+this.configs.id, "shown", this.day_next);
    }
  }
}
customElements.define('sys-exit', exitModal);

// --------------------------
// Countdown Cart
// --------------------------

class cartCountdown extends HTMLElement {
  constructor() {
    super();
    let settMinutes = 60 * this.getAttribute("time"), time = parseInt(sessionStorage.getItem('cartTime')), display = this.querySelector('#timer_count');
    this.config = JSON.parse(this.getAttribute("config"));
    var self = this;
    function startTimer(duration, display) {
      let timer = duration, minutes, seconds;
      let countdown = setInterval(function () {
          minutes = parseInt(timer / 60, 10)
          seconds = parseInt(timer % 60, 10);
          minutes = minutes < 10 ? minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          display.textContent = minutes + self.config.labelm + " : " + seconds + self.config.labels;
          let calc = 60 * parseInt(timer / 60, 10) + parseInt(timer % 60, 10);
          if (!Shopify.designMode) {
            sessionStorage.setItem('cartTime', calc);
          }
          if (--timer < 0) {
            window.clearInterval(countdown);
            display.textContent = 0 + self.config.labelm + " : " + 0 + self.config.labels;
            fetch(Shopify.routes.root+"cart/clear.js")
            .then((response) => response.text())
            .then((text) => {
              console.log("Clear cart")
              window.location.href = `${Shopify.routes.root}cart`;
            })
            .catch((e) => {
              console.error(e);
            });
          }
      }, 1000);
    };
    if (time > 0) {startTimer(time, display);}
    else {startTimer(settMinutes, display)}
  }
}
customElements.define('cart-countdown', cartCountdown);

// --------------------------
// Form status
// --------------------------


const contactForm = $$4('form[action^="/contact"]');
contactForm.forEach(function(form) {
  form.addEventListener("submit", function(event){
    sessionStorage.setItem("the4:recentform", this.getAttribute("id"));
  })
});
const goToForm = (id) => {
  const form = $4(`#${id}`);
  const formParent = form.closest("hdt-modal");
  const buttonForm = $4(`[aria-controls="${formParent.id}"]`);
  // console.log(buttonForm)
  if (buttonForm) {
    buttonForm.scrollIntoView({ behavior: 'smooth' });
  }
}
var recentform = sessionStorage.getItem("the4:recentform") || "";

if (location.href.indexOf('contact_posted=true') > 0 && recentform !== "" ) {
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
  if ($4('.form-status-mirror-'+ recentform)) {
    $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
  }
  goToForm(recentform);
}

else if (location.href.indexOf('customer_posted=true') > 0 && recentform !== "" ) {
  document.addEventListener('the4:recentform', (event)=>{
    let modal_id = document.getElementById(event.detail.recentform).getAttribute('data-id') || document.getElementById(event.detail.recentform).getAttribute('id');
    document.getElementById(modal_id)?.setAttribute('open','')
  })
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
  goToForm(recentform);
}
else if (location.href.indexOf('contact_posted=true') > 0 && location.href.indexOf('#') > 0 ) {
  var recentform = location.href.split("#")[1];
  if ($id4(recentform).length > 0) {
    sessionStorage.setItem("the4:recentform", recentform);
    $id4(recentform).classList.add("on-live");
    if ($4('.form-status-mirror-'+ recentform)) {
      $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
    }
    goToForm(recentform);
  }
}



// --------------------------
// Total sold flash
// --------------------------
class flashSold extends VariantChangeBase {
  constructor() {
    super();
    var self = this;
    this.time = this.getAttribute("time");
    this.config = JSON.parse(this.getAttribute("flash-sold"));
    this.mins = this.config.mins;
    this.maxs = this.config.maxs;
    this.mint = this.config.mint;
    this.maxt = this.config.maxt;
    this.dataID = this.config.id;
    this.getS = sessionStorage.getItem("soldS" + this.dataID) || this.getRandomInt(this.mins, this.maxs);
    this.getT = sessionStorage.getItem("soldT" + this.dataID) || this.getRandomInt(this.mint, this.maxt);
    this.numS = parseInt(this.getS);
    this.numT = parseInt(this.getT);
    this.intervalTime = parseInt(this.config.time);
    this.$sold = this.querySelector('[data-sold]');
    this.$hour = this.querySelector('[data-hour]');
    this.limitMinMax();
    this.updateSold(this.numS, this.numT);
    setInterval(function () {
      this.numS = this.numS + self.getRandomInt(1, 4);
      this.numT = this.numT + (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1) * 1;
      self.limitMinMax();
      self.updateSold(self.numS, self.numT);
    }, this.intervalTime);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  updateSold(num1, num2) {
    this.$sold.innerHTML = num1;
    this.$hour.innerHTML = Math.floor(this.numT);
    sessionStorage.setItem("soldS" + this.dataID, num1);
    sessionStorage.setItem("soldT" + this.dataID, num2);
  }
  limitMinMax() {
    if (this.numS > this.maxs) this.numS = self.getRandomInt(this.mins, this.maxs)
    if (this.numT > this.maxt) this.numT = self.getRandomInt(this.mins, this.maxt)
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = "block"
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('flash-sold', flashSold);

// --------------------------
// Multi brands
// --------------------------
var hdtNavLoading = true;
class multiBrands extends HTMLElement {
  constructor() {
    super();
    if($id4("hdt-nav-ul").classList.value.includes("hdt-nav-loading") < 0){
      return false;
    }
    this.item = $$4("[item-brand]", this);
    // this.section_id = this.getAttribute("s_id");
    // this.url = "";
    if(this.item.length) {
      for(var i=0; i < this.item.length; i++) {
        if (this.item[i].parentElement.classList.value.includes("is--active")) {
          this.url = this.item[i].getAttribute("href");
          const lazyMb = $4('hdt-lazy-submenu#sub-hdt-nav-mb');
          if (lazyMb) {
            lazyMb.addEventListener('lazyhtml:added', () => $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open",""));
          } else {
            $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open","");
          }
          // localStorage.setItem("the4:brand:url", this.url);
          break;
        }
      }
      // if(this.url === "") {
      //   this.url = localStorage.getItem("the4:brand:url") || Shopify.routes.root;
      //   for(var i=0; i < this.item.length; i++) {
      //     if (this.item[i].getAttribute("href") === this.url) {
      //       this.item[i].parentElement.classList.add("is--active");
      //       $4("#hdt-nav-ul-mb summary[data-url=\""+ this.url +"\"]").parentElement.setAttribute("open","");
      //       if (i > 0) {
      //         this._init();
      //       }
      //       break;
      //     }
      //   }
      // }
    }
  }
  // _init(){
  //   var nameStorage = "the4:brand:nav" + this.url.replace(/\//g,'-');
  //   if(!Shopify.designMode && sessionStorage.getItem(nameStorage) !== null){
  //     $id4("hdt-nav-ul").innerHTML = sessionStorage.getItem(nameStorage);
  //     $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //     return;
  //   }
  //   if (!hdtNavLoading) {
  //     return;
  //   }
  //   fetch(this.url + "?section_id=" + this.section_id)
  //     .then((response) => response.text())
  //     .then((text) => {
  //       const html = document.createElement('div');
  //       html.innerHTML = text;
  //       const nav = html.querySelector('#hdt-nav-ul');
  //       if (nav && nav.innerHTML.trim().length) {
  //         $id4("hdt-nav-ul").innerHTML = nav.innerHTML;
  //         $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //         sessionStorage.setItem(nameStorage, nav.innerHTML.trim().replace(/^\s+|\s+$|\n/gm,''));
  //       }
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //     });
  //   hdtNavLoading = false;
  // }
}

customElements.define('multi-brands', multiBrands);

// --------------------------
// Footer Accordion
// --------------------------

class FooterAccordion extends HTMLElement{
  constructor(){
    super();
    this.id = this.getAttribute('id');
    this.heading = $4(`#Heading-${this.id}`,this);
    this.content = $4(`#Content-${this.id}`,this);
    this.config = JSON.parse(this.getAttribute('config'));
    this.flag = false;
    if(!this.config){
      this.config = {
        accordion: true
      }
    }
    // if(window.innerWidth > 767){
    //   return;
    // }
    if(this.config.accordionMobile){
      this.init();
      window.addEventListener('resize', () => {
        window.innerWidth > 767 ? this.removeAttribute('open') : this.flag ? " " : this.init();
      })
    }
  }
  static observedAttributes = ['open'];
  get open(){
    return this.hasAttribute('open');
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.open ? this.content.style.setProperty('height', `${this.content.scrollHeight}px`) : this.content.style.removeProperty('height');
  }
  init(){
    window.innerWidth < 768 ? this.handleHeadingClick() : this.removeAttribute('open');
  }
  handleHeadingClick(){
    this.flag = true;
    this.heading.addEventListener('click', () =>{
      if(window.innerWidth > 767) return;
      this.open ? this.removeAttribute('open') : this.setAttribute('open', '');
    })
  }
}
customElements.define('hdt-faccordion',FooterAccordion);

// --------------------------
// Delivery Time
// --------------------------
// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "@theme/dayjs";
dayjs.locale('en'); // use locale globally
class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    this.offDays          = this.config.off_day.replace(/ /g,'').split(",");
    this.nowDay           = dayjs();
    var format_day       = this.config.format_day,
        time             = this.config.time.replace("24:00:00", "23:59:59"),
        arrDayWeek       = ["SUN","MON","TUE","WED","THU","FRI","SAT"],
        dateStart        = this.config.estimateStartDate || 0,
        dateEnd          = this.config.estimateEndDate || 0,
        excludeDays      = this.config.cut_day.replace(/ /g,'').split(","),
        startDay         = dayjs(),
        i                = 0,
        endDay           = dayjs(),
        j                = 0,
        nowTime          = this.nowDay.format('HHmmss'),
        timeint          = time.replace(/ /g,'').replace(/:/g,''),

        arrDay           = themeHDN.extras.order.dayNames.replace(/ /g,'').split(","),
        arrMth           = themeHDN.extras.order.monthNames.replace(/ /g,'').split(",");

    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay   = this.nowDay.add(1, 'day');
      startDay = startDay.add(1, 'day');
      endDay   = endDay.add(1, 'day');
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if ( this.config.mode == '2' ) {

      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
          j--;
        }
      }

    }
    else {

      // START DATE
      startDay = startDay.add(dateStart, 'day');
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }

      // END DATE
      endDay = endDay.add(dateEnd, 'day');
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');

    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */

    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format('D')),
    daystStart       = startDayDInt + this.nth(startDayDInt),
    MntStart         = arrMth[ parseInt(startDay.format('M')) -1 ],
    dayStart         = arrDay[ parseInt(startDay.format('d')) ],

    EndDayDInt       = parseInt(endDay.format('D')),
    daystEnd         = EndDayDInt + this.nth( EndDayDInt ),
    MntEnd           = arrMth[ parseInt(endDay.format('M')) -1 ],
    dayEnd           = arrDay[ parseInt(endDay.format('d')) ];

    //console.log( startDayDInt, EndDayDInt )
    if($4('[data-start-delivery]', this)) $4('[data-start-delivery]', this).innerHTML = startDay.format(format_day).replace('t44',dayStart).replace('t45',daystStart).replace('t46',MntStart);
    if($4('[data-end-delivery]', this)) $4('[data-end-delivery]', this).innerHTML = endDay.format(format_day).replace('t44',dayEnd).replace('t45',daystEnd).replace('t46',MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter( onlyUnique );
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = ""
        if( variant.variant_state.pre_order && this.config?.hideWithPreorder ) {
          this.closest(".hdt-product-info__item").style.display = "none"
        }
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('order-delivery', orderDelivery);
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute('config'));
    const time = this.config.time.replace("24:00:00", "23:59:59")

    if (time == '19041994') return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay  = !this.textTemp.includes('[days]');
    let today        = dayjs();

    const nowTime      = today.format('HHmmss'),
          configTime   = time.replace(/ /g,'').replace(/:/g,'')

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, 'day');
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(`${today.format('YYYY-MM-DD')} ${time}`).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval( this.#update.bind(this), this.textTemp.includes('[secs]') ? 1000 : 60000);
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
    let   hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days*24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp.replace('[days]', String(days).padStart(2, '0')).replace('[hours]', String(hours).padStart(2, '0')).replace('[mins]', String(minutes).padStart(2, '0')).replace('[secs]', String(seconds).padStart(2, '0'));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define('hdt-countdown-simple', countdownSimple);

class countdownTimer extends VariantChangeBase {
  constructor() {
    super();
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.style.display = ""
      }
      else {
        this.style.display = "none"
      }
    }
  }
}
customElements.define('countdown-timer', countdownTimer);

// quick order list

var createCartPromise = ()=> {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var _upate_qty,
upate_qty_fn;
class QuickOrderList extends HTMLElement {
  constructor() {
    super();
    const ON_CHANGE_DEBOUNCE_TIMER = 300;
    this.actions = {
      add: 'ADD',
      update: 'UPDATE',
    };
    this.quickOrderListId = '#'+this.id;
    this.sectionId = this.dataset.sectionId;
    this.updateThink();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    getterAdd(_upate_qty, this);
    document.addEventListener("cart:push:section.id", (event) => event.detail.sections.push(this.sectionId));
  }
  onSubmit(event) {
    event.preventDefault();
  }

  connectedCallback() {
    document.addEventListener($4('hdt-cart-drawer') ? 'cart:drawer:change' : 'variant:add', this.fetchQuickOrder.bind(this) );
  }
  //disconnectedCallback() {}

  updateThink() {
    this.items_in_cart = $4('[update_items_in_cart]', this);
    this.items_price_in_cart = $4('[update_items_price_in_cart]', this);
    $4('form#QuickOrderList', this).addEventListener('submit', this.onSubmit.bind(this));
  }
  fetchQuickOrder(event) {
    const html = new DOMParser().parseFromString(event.detail.sections[this.sectionId], 'text/html');
    const sourceQty = html.querySelector(this.quickOrderListId);
    $4('form#QuickOrderList', this).removeEventListener('submit', this.onSubmit.bind(this));
    this.innerHTML = sourceQty.innerHTML;
    document.dispatchEvent(new CustomEvent("currency:update"));
    this.updateThink();
    // fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html');
    //     const sourceQty = html.querySelector(this.quickOrderListId);
    //     this.innerHTML = sourceQty.innerHTML;
    //   })
    //   .catch((e) => { console.error(e); });
  }
  onChange(event) {
    const inputValue = parseInt(event.target.value);
    const cartQuantity = parseInt(event.target.dataset.cartQuantity);
    const index = event.target.dataset.index;
    const quantity = inputValue - cartQuantity;

    if (cartQuantity > 0) {
      this.updateQuantity(index, inputValue, this.actions.update);
    } else {
      this.updateQuantity(index, quantity, this.actions.add);
    }
  }
  onLoading(id){
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy',true);
    $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy',true));
  }
  deLoading(id){
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy',false);
    $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy',false));
  }
  removeButton(id,quantity){
    quantity !== 0 ? $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).removeAttribute('hidden') : $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).setAttribute('hidden','');
  }
  updateInCart(id,variant_in_cart){
    //  label
    $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).removeAttribute('hidden');
    let variant_qty_cart = $4(`#Variant-${id} .hdt-quantity-cart`, this);

    //  totals
    let variant_total = $4(`#Variant-${id} [variant_update_price]`, this);

    // update
    if(variant_in_cart?.length !== 0 && variant_in_cart){
      let variant_total_price = parseFloat(variant_in_cart.original_line_price)
      variant_qty_cart.innerText = variant_in_cart.quantity
      variant_total.innerText = formatMoney(variant_total_price,themeHDN.settings.currencyFormat);
      variant_total.setAttribute('data-variant-price', variant_total_price);
    } else {
      variant_qty_cart.innerText = 0;
      variant_total.innerText = formatMoney(0,themeHDN.settings.currencyFormat);
      variant_total.setAttribute('data-variant-price', 0);
      $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).setAttribute('hidden','');
    }
    this.removeT4CrurrencyData(variant_total);
  }
  removeT4CrurrencyData(el, dataset = el.dataset) {
    for (const [key, value] of Object.entries(dataset)) {
      if(key.toLowerCase().indexOf("currency") >= 0) delete el.dataset[key];
    }
  }
  updateTotalInCart(){
    let items_total = 0;
    let items_price = 0;

    // update items_total
    let items = $$4('[data-cart-quantity]', this);
    items.forEach(item => {
      return items_total += parseInt(item.getAttribute('data-cart-quantity'));
    })
    this.items_in_cart.innerText = items_total;

    // update items_price
    let prices = $$4('[data-variant-price]', this);
    prices.forEach(price =>{
      return items_price += parseFloat(price.getAttribute('data-variant-price'));
    })
    this.items_price_in_cart.innerText = formatMoney(items_price,themeHDN.settings.currencyFormat);
    this.removeT4CrurrencyData(this.items_price_in_cart);
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
  // update quantity product
  updateQuantity(id, quantity, action) {
    document.dispatchEvent(new CustomEvent("theme:loading:doing",{bubbles:!0}));
    this.removeButton(id,quantity);
    this.onLoading(id);
    let bundleSections = [];
    document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: true, detail: { sections: bundleSections } }));
    let routeUrl = `${Shopify.routes.root}cart/change.js`;
    let body = JSON.stringify({
      quantity,
      id,
      sections_url: window.location.pathname,
      sections: bundleSections.join(",")
    });
    let fetchConfigType;

    if (action === this.actions.add) {
      fetchConfigType = 'javascript';
      routeUrl = `${Shopify.routes.root}cart/add.js`;
      body = JSON.stringify({
        items: [
          {
            quantity: parseInt(quantity),
            id: parseInt(id),
          },
        ],
        sections_url: window.location.pathname,
        sections: bundleSections.join(",")
      });
    }

    fetch(`${routeUrl}`, { ...this.fetchConfig(fetchConfigType), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      let cartContent = JSON.parse(state);
      const quantityElement = document.getElementById(`Quantity-${id}`);

      if(quantity === 0){
        this.resetQuantityInput(id,quantityElement,true);
      }
      quantityElement.setAttribute('data-cart-quantity',quantity);
      getterRunFn(_upate_qty, this, upate_qty_fn).call(this, cartContent, parseInt(id), action, bundleSections)
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.updateTotalInCart();
      document.dispatchEvent(new CustomEvent("currency:update"));
      document.dispatchEvent(new CustomEvent("theme:loading:done",{bubbles:!0}));
      this.deLoading(id);
    });
  }
  resetQuantityInput(id, quantityElement,resetValue) {
    const input = quantityElement ?? document.getElementById(`Quantity-${id}`);
    input.value = input.getAttribute('value');
    resetValue ? input.value = 0 : input.value = input.getAttribute('value');
  }
  updateError(updatedValue, id) {
    let message = '';
    if (typeof updatedValue === 'undefined') {
      message = window.cartStrings.error;
    } else {
      message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
    }
    this.updateLiveRegions(id, message);
  }

  updateLiveRegions(id, message) {
    const variantItemError = this.getElementById('Quick-order-list-item-error');
    if (variantItemError) {
      $4('.hdt-variant-item__error-text', variantItemError).innerHTML = message;
      variantItemError.removeAttribute('hidden');
    }
  }

}
_upate_qty = new WeakSet();
upate_qty_fn = async function(cartContent, id, action) {
  const variant_in_cart = cartContent.items.find((item) => item.variant_id === id);
  this.updateInCart(id,variant_in_cart);
  this.dispatchEvent(new CustomEvent("quickOrder:change", { bubbles: false}));
  //document.dispatchEvent(new CustomEvent("cart:refresh"));
  let cart = cartContent;
  if (action === this.actions.add) {
    cart = await createCartPromise();
    cart.sections = cartContent.sections;
  }
  document.dispatchEvent(new CustomEvent("cart:change", {
    bubbles: true,
    detail: {
      baseEvent: "line-item:change",
      cart,
      disabledDrawerChange: true
    }
  }));
};

customElements.define('hdt-quick-order-list', QuickOrderList);

// remove variant in cart
class QuickOrderListRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click',(event) => {
      event.preventDefault();
      const quickOrderList = this.closest('hdt-quick-order-list');
      quickOrderList.updateQuantity(this.dataset.index, 0);
      this.setAttribute('hidden','');
    });
  }
}

customElements.define('hdt-quick-order-list-remove-button', QuickOrderListRemoveButton);

// remove all variant in cart
class QuickOrderListRemoveAllButton extends HTMLElement {
  constructor() {
    super();
    this.quickOrderList = this.closest('hdt-quick-order-list');
    const allVariants = Array.from(this.quickOrderList.querySelectorAll('[data-variant-id]'));
    const items = {};
    const list_variants = []
    let hasVariantsInCart = false;

    allVariants.forEach((variant) => {
      const cartQty = parseInt(variant.dataset.cartQty);
      if (cartQty > 0) {
        hasVariantsInCart = true;
        items[parseInt(variant.dataset.variantId)] = 0;
        list_variants.push(variant.dataset.variantId);
      }
    });

    if (!hasVariantsInCart) {
      this.setAttribute('hidden','')
    }

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.quickOrderList.updateMultipleQty(items,list_variants);
      this.setAttribute('hidden','')
    });
  }
}

customElements.define('hdt-quick-order-list-remove-all-button', QuickOrderListRemoveAllButton);


// Begin instagram feed api
const dataInstagramCache = {};
class instagramFeedAPI extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        this.refresh_ins();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const {acc,id} = this.config;
        var data = sessionStorage.getItem('hdt_ins'+acc+id);
        if (data != null && data != '') {
          sessionStorage.removeItem('hdt_ins'+acc+id);
        }
      })
    }
  }
  connectedCallback() {
    this.refresh_ins();
  }
  refresh_ins(){
    const {acc,id} = this.config;

    if (acc == '') return;

    var data = sessionStorage.getItem('hdt_ins'+acc+id);

    if (data != null && data != '') {
      // calculate expiration time for content,
      // to force periodic refresh after 30 minutes
      var now = new Date(),
      expiration = new Date(JSON.parse(data).timestamp);

      expiration.setMinutes(expiration.getMinutes() + 30);

      // ditch the content if too old
      if (now.getTime() > expiration.getTime()) {
        data = null;
        sessionStorage.removeItem('hdt_ins'+acc+id);
      }
    }
    if ( data != null && data != '' ) {
      this.instagramHTML(JSON.parse(data).content,false);
    }
    else{
      if (dataInstagramCache[acc]) {
        $4('.hdt-slider__container', this).innerHTML = dataInstagramCache[acc];
        $4('.hdt-ins-loading', this)?.remove();
        const lazySlider = $4('hdt-slider-lazy', this);
        if (lazySlider) {
          lazySlider.hidden = false;
          lazySlider.InitLazy();
        }
        return;
      }

      fetch('https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token='+atob(acc))
      .then((response) => {
        if(!response.ok) { throw new Error("not ok"); }
        return response.json()
      })
      //.then(function(res)
      .then((res) => {
        //console.log('Success:', res);
         this.instagramHTML(res.data,true);
      })
      .catch(() => {
        $4('.hdt-ins-loading', this)?.remove();
        console.error("Instagram Feed:error fetch");
      });
    }
  }
  instagramHTML(data,saveSessionStorageIns) {
    const arrIcons = ($4('.hdt-icons-ins-svg', this).innerHTML || '').split('[hdtplit]'),
    icons = {
       image : arrIcons[0],
       video : arrIcons[1],
       carousel_album: arrIcons[2]
    },
    {id, acc, target, limit} = this.config;
    let html = '';

    data.forEach( (el, index) => {
      if (index >= limit) return 0;
      const media_type = el.media_type.toLowerCase();
      html += `<div class="hdt-slider__slide hdt-ins-type-${media_type}"><a calc-nav data-no-instant rel="nofollow" class="hdt-ins-inner hdt-block hdt-relative hdt-oh hdt-radius" href="${el.permalink}" target="${target}"><div class="hdt-ratio"><img src="${el.thumbnail_url || el.media_url}" class="hdt-ins-img" loading="lazy"></div><div class="hdt-ins-icon">${icons[media_type]}</div></a></div>`
    });
    dataInstagramCache[acc] = html;
    $4('.hdt-slider__container', this).innerHTML = html;
    $4('.hdt-ins-loading', this)?.remove();
    const lazySlider = $4('hdt-slider-lazy', this);
    if (lazySlider) {
      lazySlider.hidden = false;
      lazySlider.InitLazy();
    }

    if(saveSessionStorageIns){
      sessionStorage.setItem('hdt_ins'+acc+id, JSON.stringify({
        timestamp: new Date(),
        content: data
      }));
    }
  }
}
customElements.define('ins-feed-api', instagramFeedAPI);

// End instagram feed api

// Tab main-brands //
class TabsBrands extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('.hdt-tab-link');
    this.tabs = this.querySelectorAll('.hdt-tab-content');
    this.addAllListeners();
  }

  addAllListeners() {
    this.links.forEach(link => {
      link.addEventListener('click', () => {
        const tabName = link.getAttribute('data-filter');
        if (tabName === 'all') {
          this.openAllTabs();
        } else {
          this.openTab(tabName);
        }
        this.links.forEach(item => {
          item.classList.remove('is--active');
        });
        if (!link.classList.contains('is--active')) {
          link.classList.add('is--active');
        }
      });
    });
  }

  openAllTabs() {
    this.tabs.forEach(content => {
      content.style.display = 'block';
      content.style.height = 'auto';
    });
    this.querySelector('[data-filter="all"]').classList.add('is--active');
  }

  openTab(tabName) {
    this.tabs.forEach(content => {
      if (content.id === tabName) {
        content.style.display = 'block';
        content.classList.add('slideInRight');
      } else {
        content.style.display = 'none';
        content.classList.remove('slideInRight');
      }
    });
  }

  connectedCallback() {
    this.addAllListeners();
  }
  disconnectedCallback() {
  }
}

customElements.define('tabs-brands', TabsBrands);

//  //


class countryFilter extends HTMLElement {
  constructor() {
    super();
    this.search = $4('[name=country_filter]', this);
    this.reset = $4(".hdt-country_filter__reset", this);
    if (this.search) {
      this.search.addEventListener(
        'input',
        debounce((event) => {
          this.filterCountries();
        }, 200).bind(this)
      );
    }
    this.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));

  }
  filterCountries(){
    const searchValue = this.search.value.toLowerCase();
    const allCountries = this.closest("hdt-popover").querySelectorAll('hdt-richlist button');
    let visibleCountries = allCountries.length;
    allCountries.forEach((item) => {
      const countryName = item.getAttribute('data-name').toLowerCase();
      if (countryName.indexOf(searchValue) > -1) {
        item.classList.remove('hdt-d-none');
        visibleCountries++;
      } else {
        item.classList.add('hdt-d-none');
        visibleCountries--;
      }
    });
    this.closest("hdt-popover").updatePos();
    this.closest("hdt-popover").shadowRoot.querySelector('.hdt-current-scrollbar').scrollTop = 0;
  }

  onSearchKeyDown(event) {
    if (event.code.toUpperCase() === 'ENTER') {
      event.preventDefault();
    }
  }
}

customElements.define('country-filter', countryFilter);


// check purchase code
if(Shopify.designMode){

  /**
  * If it's a global variable then window[variableName] or in your case window["onlyVideo"] should do the trick.
  * https://stackoverflow.com/questions/5613834/convert-string-to-variable-name-in-javascript
  */
  function isStorageSupported(type) {
    // Return false if we are in an iframe without access to sessionStorage
    // window.self !== window.top

    var storage = (type === 'session') ? window.sessionStorage : window.localStorage;

    try {
      storage.setItem('t4s', 'test');
      storage.removeItem('t4s');
      return true;
    } catch (error) {
      return false;
    }
  };

  var ThemeCode    = atob(window[atob('Y0hWeVkyaGg=')]),
      ThemeName_base64 = window[atob('VkdobGJXVk9ZVzFsVkRR')],
      ThemeName            = atob(ThemeName_base64),
      CookieName           = 'SXNBY3RpdmVUaGVtZQ=='+ThemeName_base64,
      ShopEmail            = atob(window[atob('VTJodmNFMWxiMVEw')]),
      isTrueSet            = (sessionStorage.getItem(CookieName) === 'true' ),
      str_temp_active      = atob('I3Q0cy10ZW1wLWtleS1hY3RpdmU='), // #t4s-temp-key-active
      str_purchase         = atob('cHVyY2hhc2VfY29kZXQ0'); // purchase_codet4;

      // console.log(ThemeCode,ThemeName,ShopEmail,CookieName,str_temp_active,str_purchase)
  function alert_active_html() {
    return `<section id="${str_purchase}" style="display: flex !important">${ $4(str_temp_active).innerHTML }</section>`;
  };

  // console.log('ThemeCode', ThemeCode, isTrueSet)

  if (ThemeCode == '') {
    let dom1 = (new DOMParser).parseFromString(alert_active_html(), "text/html");
    document.body.append(dom1.body.firstElementChild);
    let dom2 = (new DOMParser).parseFromString('<div id="luffyabc194"><style>body>*:not(#purchase_codet4) {opacity: 0;pointer-events: none;</style></div>', "text/html");
    document.body.prepend(dom2.body.firstElementChild);
    sessionStorage.removeItem(CookieName);
    localStorage.removeItem(CookieName);
  }
  else if ( !isTrueSet ) {

    //console.log(ShopEmail, ThemeName, ThemeCode);

    var domain     = window.location.hostname,
    mix        = ['4','t','h','e','p','l','i','c','o','/','.',':','n','s'],
    mix_domain = mix[2]+mix[1]+mix[1]+mix[4]+mix[13]+mix[11]+mix[9]+mix[9]+mix[5]+mix[6]+mix[7]+mix[10]+mix[1]+mix[2]+mix[3]+mix[0]+mix[10]+mix[7]+mix[8]+mix[9]+mix[5]+mix[6]+mix[7]+mix[3]+mix[12]+mix[13]+mix[3]+mix[9]+mix[7]+mix[2]+mix[3]+mix[7]+'k',
    data       = {
      "shopify_domain": domain,
      "email"         : ShopEmail,
      "theme"         : ThemeName,
      "purchase_code" : ThemeCode
    };

    fetch(mix_domain, {
      "headers": {
        "accept": "*/*",
        "cache-control": "no-cache",
        "x-requested-with": "XMLHttpRequest"
      },
      "body": btoa (encodeURIComponent(JSON.stringify(data))) ,
      "method": "POST",
      "mode": "cors"
    })
    .then(function(response) {
      if(response.ok){
        return response.json()
      } throw ""
    })
    .then(function(response) {
      let dom = (new DOMParser).parseFromString(alert_active_html(), "text/html");

      if ( response.status == 1) {

        dom.body.firstElementChild.innerHTML = "<p>ACTIVATED SUCCESSFULLY. Thanks for buying my theme!</p>";
        document.body.append(dom.body.firstElementChild);

        // Set a cookie to expire in 1 hour in Javascript
        var isActived = localStorage.getItem(CookieName);
        sessionStorage.setItem(CookieName, 'true')

        if (isActived === 'true') {
          $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
          // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
        }
        else {
          localStorage.setItem(CookieName, "true");
          setTimeout(function(){
            $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
            // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
          }, 1000);
        }

      }
      else {

        var mess = response.message;
        if (mess == "No sale belonging to the current user found with that code") {

          dom.body.firstElementChild.innerHTML = "<p>Purchase code error. It is a sales reversal or a refund. :(((</p>";

        }
        else if (mess.length == 58 || mess.length == 101) {
          dom.body.firstElementChild.innerHTML = "<p>That license key doesn't appear to be valid. Please check your purchase code again!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";

        }
        else if (mess.length == 104) {
          dom.body.firstElementChild.innerHTML = "<p>The license not match with current theme.!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
        }
        else {
          try {
            var mess = mess.split('active domain `')[1].split('`. ')[0];
          }
          catch(err) {
            //var mess = mess;
          }
          dom.body.firstElementChild.innerHTML = "<p>Your purchase code is invalided since it is being activated at another store "+mess+".<br> Please open a ticket at <a class='cg' href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> to get quick assistance.</p>";
        }
        document.body.append(dom.body.firstElementChild);

      }

    }).catch(function(e) {
    //}).catch((e)=>{
      console.error(e)
    });

  }
}
// end check purchase code

// readmore collection description
class DescriptionShort extends HTMLElement{
  constructor(){
    super();
    this.button_readmore = $4('[data-read-more]', this);
    this.button_readless = $4('[data-read-less]', this);
    this.short_des = $4('.hdt-collection-description-short', this);
    this.full_des = $4('.hdt-collection-description-full', this);
    if(!this.button_readmore || !this.button_readless || !this.short_des || !this.full_des){
      return;
    }
    this.button_readmore.addEventListener('click',(e)=>{
      // console.log(this);
      e.preventDefault();
      this.short_des.classList.add('hdt-hidden');
      this.full_des.classList.remove('hdt-hidden');
    })
    this.button_readless.addEventListener('click',(e)=>{
      // console.log(this);
      e.preventDefault();
      this.short_des.classList.remove('hdt-hidden');
      this.full_des.classList.add('hdt-hidden');
    })
  }
}
customElements.define('description-short',DescriptionShort)

// product description - readmore
class ProductDescription extends HTMLElement{
  constructor(){
    super();
  }
  connectedCallback(){
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.init();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
  }
  init(){
   
    this.lm_btn = this.querySelector('[data-button]');
    this.content = this.querySelector('[data-content]');
    this.m_h = parseInt(this.dataset.heightLimit);
    if(!this.lm_btn || !this.content || !this.m_h) return;
   
    let content_h = this.content.scrollHeight;
    // console.dir(this.content);
    if(this.m_h > content_h){
      this.lm_btn.style.setProperty('display', 'none');
      return;
    }

    this.content.style.setProperty('--height', `${content_h}px`);
    this.content.style.setProperty('max-height', `${this.m_h}px`);
    this.content.style.setProperty('--max-height', `${this.m_h}px`);

    this.lm_btn.addEventListener('click',()=>{
      this.classList.toggle('is--less');
    })
  }
}
customElements.define('product-description',ProductDescription);


// ===========================
//        QUICK SEARCH
// ===========================
class QuickSearch extends HTMLElement{
  constructor(){
    super();
    this.inpt = this.closest('hdt-predictive-search').querySelector('form input[data-input-search]');
    this.query = this.querySelector('a');
    if(!this.inpt || !this.query) return;
    this.onClick();
  }
  onClick(){
    let self = this;
    this.query.addEventListener('click',(e) => {
      e.preventDefault();
      self.inpt.value = e.target.dataset.query;
      self.inpt.dispatchEvent(new Event('input'));
    })
  }
}
customElements.define('hdt-quick-search', QuickSearch);


// tabHover
class tabHover extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("mouseenter", (event) => {
      this.closest("hdt-tab").querySelector("button[aria-current=\"true\"]")?.setAttribute("aria-current", false);
      this.parentElement.click()
    });
  }
}
customElements.define("tab-hover", tabHover);


// footer accodion
function handleAccordionClick() {
  let accordion = this.parentElement;
  accordion.classList.toggle('open');
  if (window.innerWidth < 768) {
    let content = accordion.querySelector('.hdt-collapse-content');
    if(!content) return;
    if (accordion.classList.contains('open')) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0';
    }
  }
}
function updateMaxHeight() {
  if (window.innerWidth >= 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-collapse-content').forEach(function(content) {
      content.style.height = '';
    });
  }
}
document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
  element.addEventListener('click', handleAccordionClick);
});
window.addEventListener('resize', function() {
  if (window.innerWidth < 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
      element.removeEventListener('click', handleAccordionClick);
      element.addEventListener('click', handleAccordionClick);
    });
  } else {
    document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
      element.removeEventListener('click', handleAccordionClick);
    });
    updateMaxHeight();
  }
});


// video popup
class popupVideo extends HTMLElement {
  constructor(){
    super();
    this.modal = $4("hdt-modal", this);
    this.video = $4("hdt-video-player", this);
    this.modal.addEventListener("dialog:afterOpen", (e)=>{
      this.video.play()
    })
    this.modal.addEventListener("dialog:beforeClose", (e)=>{
      this.video.pause()
    })
  }
}
customElements.define('hdt-btn-popup-video', popupVideo)


class SizeAtc extends HTMLElement {
  constructor() {
    super();
    this.size = this.dataset.size;
    this.productHandle = this.dataset.productHandle;
    this.productId = this.dataset.productId;
    this.sizeOptionIndex = this.dataset.sizeOptionIndex;
    this.variants = this.dataset.variants ? JSON.parse(this.dataset.variants) : null;
    this.colorOptionIndex = this.dataset.colorOptionIndex;

    this.autoOpenCart = this.dataset.autoOpenCart !== 'false';
   

   

    this.addEventListener('click', this.handleSizeClick.bind(this));
   
    // Setup color change listener
    this.setupColorChangeListener();
  }

  setupColorChangeListener() {
    if (!this.variants || !this.colorOptionIndex) return;
   
    const cardProduct = this.closest('hdt-card-product');
    if (!cardProduct) return;
   
    // Listen for color input changes
    const colorInputs = cardProduct.querySelectorAll('input[data-option-pr]');
    colorInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updateSizeAvailability();
      });
    });
  }

  updateSizeAvailability() {
    if (!this.variants || !this.colorOptionIndex) return;
   
    const cardProduct = this.closest('hdt-card-product');
    if (!cardProduct) return;
   
    const selectedColorInput = cardProduct.querySelector('input[data-option-pr]:checked');
    if (!selectedColorInput) return;
   
    const selectedColor = selectedColorInput.value;
   
    // Filter variants by selected color
    const colorVariants = this.variants.filter(variant =>
      variant[this.colorOptionIndex] === selectedColor
    );
   
    // Get available sizes for this color
    const availableSizes = colorVariants
      .filter(variant => variant.available)
      .map(variant => variant[this.sizeOptionIndex])
      .filter((size, index, arr) => arr.indexOf(size) === index); // unique
   
    const sizeSpan = this.querySelector('.hdt-size-list-item');
    if (sizeSpan) {
      const isAvailable = availableSizes.includes(this.size);
     
      if (isAvailable) {
        sizeSpan.classList.remove('is-unavailable');
        this.removeAttribute('data-unavailable');
      } else {
        sizeSpan.classList.add('is-unavailable');
        this.setAttribute('data-unavailable', 'true');
      }
     

    }
  }

  async handleSizeClick(event) {
    event.preventDefault();

   
    if (this.dataset.unavailable === 'true') {
      return;
    }
   
    const variantId = await this.getVariantIdBySize();
   
    if (!variantId) {
      return;
    }

   
    await this.addToCart(variantId);
  }

  async getVariantIdBySize() {
    try {
     
      let product = null;
      let response = null;
     
      try {
        response = await fetch(`/products/${this.productHandle}.js`);
        if (response.ok) {
          product = await response.json();
        }
      } catch (e) {
      }
     
      if (!product) {
        try {
          response = await fetch(`/products/${this.productHandle}.json`);
          if (response.ok) {
            product = await response.json();
          }
        } catch (e) {
        }
      }
     
      if (!product) {
       
        let scriptTag = document.querySelector('script[data-product-json]');
        if (scriptTag) {
          product = JSON.parse(scriptTag.textContent);
        }
       
        if (!product) {
          scriptTag = document.querySelector('script[data-variants-json]');
          if (scriptTag) {
            const variants = JSON.parse(scriptTag.textContent);
            product = { variants: variants };
          }
        }
       
        // Thử tìm trong window object
        if (!product && window.product) {
          product = window.product;
        }
      }
     
      if (!product) {
        return null;
      }
     
     

      if (!product.variants || !Array.isArray(product.variants)) {
        return null;
      }      
      let sizeOptionIndex = this.sizeOptionIndex || 'option1';
      this.colorOptionValue = this.closest('hdt-card-product').querySelector('input[data-option-pr]:checked').value;
      this.colorOptionIndex = this.closest('hdt-card-product').querySelector('input[data-option-pr]:checked').dataset.colorOptionIndex;
     

      if (!this.sizeOptionIndex) {
        for (let variant of product.variants) {
          if (variant.option1 === this.size) {
            sizeOptionIndex = 'option1';
            break;
          } else if (variant.option2 === this.size) {
            sizeOptionIndex = 'option2';
            break;
          } else if (variant.option3 === this.size) {
            sizeOptionIndex = 'option3';
            break;
          }
        }
      }
     
      const currentSelectedVariant = this.getCurrentSelectedVariant(product);
     
      const variant = this.findMatchingVariant(product.variants, currentSelectedVariant, sizeOptionIndex);
     
      return variant ? variant.id : null;
          } catch (error) {
        console.error('Error fetching product:', error);
        return null;
      }
  }

  async addToCart(variantId) {
    try {
      this.setAttribute('aria-busy', 'true');
     
      document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
     
      let bundleSections = ['cart-drawer'];
      document.dispatchEvent(new CustomEvent("cart:push:section.id", {
        bubbles: true,
        detail: { sections: bundleSections }
      }));
     
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }],
          sections_url: window.location.pathname,
          sections: bundleSections.join(",")
        })
      });

      if (response.ok) {
        const cartContent = await response.json();
       
        const cart = await createCartPromise();
        cart.sections = cartContent.sections;
       

       
        document.dispatchEvent(new CustomEvent("cart:count:update", {
          bubbles: true,
          detail: {
            item_count: cart.item_count || 0
          }
        }));
       
        this.forceUpdateCartBadges(cart.item_count || 0);
       
        document.dispatchEvent(new CustomEvent("cart:drawer:change", {
          bubbles: true,
          detail: {
            cart,
            sections: cartContent.sections || {},
            variantId: variantId
          }
        }));
       
        document.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "line-item:change",
            cart,
            sections: cartContent.sections || {}
          }
        }));
       
        await this.updateCartDrawerContent(cartContent.sections, cart.item_count);
       
        if (this.autoOpenCart) {
          setTimeout(() => {
            this.safeOpenCartDrawer();
          }, 100);
        }
       
      } else {
        const error = await response.json();
        console.error('Add to cart error:', error.message || error.description);
      }
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      document.dispatchEvent(new CustomEvent("currency:update"));
      document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
      this.setAttribute('aria-busy', 'false');
    }
  }

  getCurrentSelectedVariant(product) {
   
    // Method 1: Hidden input
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
    if (hiddenInput && hiddenInput.value && product && product.variants) {
     
      const variant = product.variants.find(v => v.id == hiddenInput.value);
      if (variant) {
        return variant;
      }
    }
   
    // Method 2: Variant picker attribute
    const variantPicker = document.querySelector('hdt-variant-picker[selected-variant]');
    if (variantPicker && product && product.variants) {
      const selectedVariantId = variantPicker.getAttribute('selected-variant');
      const variant = product.variants.find(v => v.id == selectedVariantId);
      if (variant) {
        return variant;
      }
    }
   
    // Method 3: Check all option inputs
    const optionInputs = document.querySelectorAll('input[name^="option"]:checked, select[name^="option"]');
    if (optionInputs.length > 0 && product && product.variants) {
      const selectedOptions = {};
      optionInputs.forEach(input => {
        const optionName = input.name;
        selectedOptions[optionName] = input.value;
      });
     
      const variant = product.variants.find(v => {
        return Object.keys(selectedOptions).every(option =>
          v[option] === selectedOptions[option]
        );
      });
     
      if (variant) {
        return variant;
      }
    }
   
    // Method 4: Check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId && product && product.variants) {
      const variant = product.variants.find(v => v.id == variantId);
      if (variant) {
        return variant;
      }
    }
   
    return null;
  }
 
  findMatchingVariant(variants, currentVariant, sizeOptionIndex) {
   
    if (!currentVariant) {
      const fallbackVariant = variants.find(variant =>
        variant.available && variant[sizeOptionIndex] === this.size && variant[this.colorOptionIndex] === this.colorOptionValue
      );
      if (fallbackVariant) {
        return fallbackVariant;
      }
    }
   
    // Tìm variant có cùng color nhưng size khác
    const otherOptions = ['option1', 'option2', 'option3'].filter(opt => opt !== sizeOptionIndex);
   

   
    const matchingVariant = variants.find(variant => {
      if (!variant.available) return false;
      if (variant[sizeOptionIndex] !== this.size) return false;
     
      // Kiểm tra các option khác phải giống hệt
      const optionsMatch = otherOptions.every(opt => variant[opt] === currentVariant[opt]);
     

     
      return optionsMatch;
    });
   
    if (matchingVariant) {
      return matchingVariant;
    }
   
    // Fallback: tìm bất kỳ variant nào có size đúng
    const fallbackVariant = variants.find(variant =>
      variant.available && variant[sizeOptionIndex] === this.size
    );
   
    return fallbackVariant;
  }
 
  forceUpdateCartBadges(itemCount) {
   
    const cartCountElements = document.querySelectorAll('hdt-cart-count');
    cartCountElements.forEach(element => {
      element.textContent = itemCount;

    });
   
    const cartDataCountElements = document.querySelectorAll('[data-count]');
    cartDataCountElements.forEach(element => {
      if (element.tagName.toLowerCase() === 'hdt-cart-drawer' ||
          element.tagName.toLowerCase() === 'hdt-main-cart' ||
          element.classList.contains('cart') ||
          element.classList.contains('mini-cart')) {
        element.setAttribute('data-count', itemCount);

      }
    });
  }
 
  async updateCartDrawerContent(sections, itemCount) {
    const cartDrawer = document.querySelector('hdt-cart-drawer');
    if (!cartDrawer) {
      return;
    }
   
    cartDrawer.setAttribute('data-count', itemCount || 0);
   
    let drawerHTML = null;
    if (sections && sections['cart-drawer']) {
      drawerHTML = sections['cart-drawer'];

    } else {

      try {
        const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
        if (response.ok) {
          drawerHTML = await response.text();
        }
      } catch (e) {
        console.error('updateCartDrawerContent: failed to fetch cart-drawer section', e);
        return;
      }
    }
   
    if (drawerHTML) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = drawerHTML;
     
      const newCartDrawer = tempDiv.querySelector('hdt-cart-drawer');
      if (newCartDrawer) {
        // Chỉ update nội dung bên trong dialog, không thay thế toàn bộ
        const existingDialog = cartDrawer.querySelector('dialog');
        const newDialog = newCartDrawer.querySelector('dialog');
       
        if (existingDialog && newDialog) {
          // Update chỉ nội dung bên trong dialog, giữ nguyên dialog element
          existingDialog.innerHTML = newDialog.innerHTML;
        } else {
          // Fallback an toàn: cố gắng tìm dialog mới và chỉ cập nhật phần bên trong
          const fallbackNewDialog = newCartDrawer.querySelector('#CartDrawer') || newCartDrawer.querySelector('dialog');
          if (existingDialog && fallbackNewDialog) {
            existingDialog.innerHTML = fallbackNewDialog.innerHTML;
          } else if (existingDialog) {
            // Không tìm thấy dialog mới, nhưng vẫn giữ nguyên element dialog hiện tại
            // và chỉ cập nhật nội dung thô để tránh thay thế node dialog
            existingDialog.innerHTML = newCartDrawer.innerHTML;
          } else {
            // Bất đắc dĩ mới thay thế toàn bộ
            cartDrawer.innerHTML = newCartDrawer.innerHTML;
          }
        }
       
        cartDrawer.setAttribute('data-count', itemCount || 0);
      } else {

      }
    }
  }
 
  safeOpenCartDrawer() {
    try {
      // Method 1: Tìm cart link và click
      const cartLink = document.querySelector('[aria-controls="CartDrawer"]');
      if (cartLink) {
        cartLink.click();

        return;
      }
     
      // Method 2: Trực tiếp mở dialog nếu có thể
      const cartDialog = document.querySelector('#CartDrawer');
      if (cartDialog && typeof cartDialog.showModal === 'function' && cartDialog.isConnected) {
        cartDialog.showModal();

        return;
      }
     
      // Method 3: Set attribute open
      if (cartDialog && cartDialog.isConnected) {
        cartDialog.setAttribute('open', '');

        return;
      }
     
    } catch (error) {
      // Silent fail
    }
  }
}

customElements.define('hdt-size-atc', SizeAtc);

// Handle no-size add to cart forms
document.addEventListener('DOMContentLoaded', function() {
  const noSizeForms = document.querySelectorAll('.hdt-no-size-atc-form');
 
  // Setup color change listeners for no-size products
  noSizeForms.forEach(form => {
    const variants = form.dataset.variants ? JSON.parse(form.dataset.variants) : null;
    const colorOptionIndex = form.dataset.colorOptionIndex;
    const variantInput = form.querySelector('.variant-id-input');
   
    if (variants && colorOptionIndex && variantInput) {
      const cardProduct = form.closest('hdt-card-product');
      if (cardProduct) {
        const colorInputs = cardProduct.querySelectorAll('input[data-option-pr]');
       
        colorInputs.forEach(input => {
          input.addEventListener('change', () => {
            const selectedColor = input.value;
           
            // Find variant with selected color
            const matchingVariant = variants.find(variant =>
              variant[colorOptionIndex] === selectedColor && variant.available
            );
           
            if (matchingVariant) {
              variantInput.value = matchingVariant.id;
            }
          });
        });
      }
    }
  });
 
  noSizeForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
     
      const button = form.querySelector('.hdt-no-size-atc-btn');
      const originalText = button.innerHTML;
     
      // Show loading state
      button.disabled = true;
      button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="3"><animate attributeName="r" values="3;5;3" dur="1s" repeatCount="indefinite"/></circle></svg><span>Adding...</span>';
     
      try {
        document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
       
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity');
        const sectionId = form.dataset.sectionId;
       
        // Đảm bảo có cart-drawer section để update
        let bundleSections = ['cart-drawer'];
        if (sectionId && !bundleSections.includes(sectionId)) {
          bundleSections.push(sectionId);
        }
       
        document.dispatchEvent(new CustomEvent("cart:push:section.id", {
          bubbles: true,
          detail: { sections: bundleSections }
        }));
       
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: parseInt(quantity)
            }],
            sections_url: window.location.pathname,
            sections: bundleSections.join(",")
          })
        });

        if (response.ok) {
          const cartContent = await response.json();
         
          // Get fresh cart data
          const cart = await createCartPromise();
          cart.sections = cartContent.sections;
         
          // Force update cart badges ngay lập tức
          const cartCountElements = document.querySelectorAll('hdt-cart-count');
          cartCountElements.forEach(element => {
            element.textContent = cart.item_count || 0;
          });
         
          // Update cart drawer element attribute
          const cartDrawer = document.querySelector('hdt-cart-drawer');
          if (cartDrawer) {
            cartDrawer.setAttribute('data-count', cart.item_count || 0);
          }
         
          // Update cart count
          document.dispatchEvent(new CustomEvent("cart:count:update", {
            bubbles: true,
            detail: {
              item_count: cart.item_count || 0
            }
          }));
         
          // Update cart drawer content trước khi dispatch events
          if (cartContent.sections && cartContent.sections['cart-drawer']) {
            console.log('🛒 Updating cart drawer content...');
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = cartContent.sections['cart-drawer'];
           
            const newCartDrawer = tempDiv.querySelector('hdt-cart-drawer');
            if (newCartDrawer && cartDrawer) {
              console.log('✅ Cart drawer elements found, updating content...');
              const existingDialog = cartDrawer.querySelector('dialog');
              const newDialog = newCartDrawer.querySelector('dialog');
             
              if (existingDialog && newDialog) {
                existingDialog.innerHTML = newDialog.innerHTML;
                console.log('✅ Dialog content updated');
              } else {
                // Fallback an toàn: ưu tiên giữ nguyên element dialog hiện tại
                const fallbackNewDialog = newCartDrawer.querySelector('#CartDrawer') || newCartDrawer.querySelector('dialog');
                if (existingDialog && fallbackNewDialog) {
                  existingDialog.innerHTML = fallbackNewDialog.innerHTML;
                } else if (existingDialog) {
                  existingDialog.innerHTML = newCartDrawer.innerHTML;
                } else {
                  cartDrawer.innerHTML = newCartDrawer.innerHTML;
                }
                console.log('✅ Cart drawer content updated (safe fallback)');
              }
              cartDrawer.setAttribute('data-count', cart.item_count || 0);
            } else {
              console.log('❌ Cart drawer elements not found', { newCartDrawer: !!newCartDrawer, cartDrawer: !!cartDrawer });
            }
          } else {
            console.log('❌ No cart-drawer section in response', cartContent.sections);
          }
         
          // Update cart drawer
          document.dispatchEvent(new CustomEvent("cart:drawer:change", {
            bubbles: true,
            detail: {
              cart,
              sections: cartContent.sections || {},
              variantId: variantId
            }
          }));
         
          // Update general cart state
          document.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "line-item:change",
              cart,
              sections: cartContent.sections || {}
            }
          }));
         
          // Update currency if needed
          document.dispatchEvent(new CustomEvent("currency:update", { bubbles: true }));
         
          // Open cart drawer
          setTimeout(() => {
            const cartLink = document.querySelector('[aria-controls="CartDrawer"]');
            if (cartLink) {
              cartLink.click();
            } else {
              // Fallback: trực tiếp mở cart drawer
              const cartDialog = document.querySelector('#CartDrawer');
              if (cartDialog) {
                cartDialog.setAttribute('open', '');
              }
            }
          }, 100);
         
          // Show success state briefly
          button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span>Added!</span>';
         
          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = originalText;
          }, 1500);
         
        } else {
          const errorData = await response.json();
          console.error('Add to cart error:', errorData);
          throw new Error(errorData.message || 'Failed to add to cart');
        }
      } catch (error) {
        console.error('Cart add error:', error);
        button.innerHTML = '<span>Error - Try again</span>';
       
        setTimeout(() => {
          button.disabled = false;
          button.innerHTML = originalText;
        }, 2000);
      }
     
      document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const topBar = document.querySelector('.hdt-top-bar');
  if (topBar) {
    if (window.innerWidth <= 767) {
      topBar.style.height = '35px';
    } else {
      topBar.style.height = '33px';
    }
  }
});

(() => {
  const initializedSkuElements = new WeakSet();

  const applySkuValue = (element, skuValue, fallbackSku) => {
    if (skuValue) {
      element.textContent = `Sku: ${skuValue}`;
      element.hidden = false;
    } else if (fallbackSku) {
      element.textContent = `Sku: ${fallbackSku}`;
      element.hidden = false;
    } else {
      element.hidden = true;
    }
  };

  const initSkuElements = (root = document) => {
    const skuElements = root.querySelectorAll('[data-product-sku]');
    skuElements.forEach((skuElement) => {
      if (initializedSkuElements.has(skuElement)) {
        return;
      }

      const cardProduct = skuElement.closest('hdt-card-product');
      if (!cardProduct) {
        return;
      }

      const fallbackSku = skuElement.dataset.defaultSku || '';
      let variants = [];
      const skuDataScript = cardProduct.querySelector('script[data-product-sku-json]');
      if (skuDataScript) {
        try {
          variants = JSON.parse(skuDataScript.textContent || '[]');
        } catch (error) {
          variants = [];
        }
      }

      const colorIndexAttr = skuElement.dataset.colorOptionIndex;
      const colorIndex = colorIndexAttr ? parseInt(colorIndexAttr, 10) : NaN;

      const findSkuForColor = (colorValue) => {
        if (!colorValue || !Number.isInteger(colorIndex) || colorIndex < 1) {
          return null;
        }

        const candidates = variants.filter((variant) => {
          if (!variant || !Array.isArray(variant.options)) {
            return false;
          }
          return variant.options[colorIndex - 1] === colorValue && variant.sku;
        });

        if (!candidates.length) {
          return null;
        }

        const availableCandidate = candidates.find((variant) => variant.available && variant.sku);
        const match = availableCandidate || candidates[0];
        return match && match.sku ? match.sku : null;
      };

      const updateSku = () => {
        if (!variants.length) {
          applySkuValue(skuElement, fallbackSku, fallbackSku);
          return;
        }

        if (Number.isInteger(colorIndex) && colorIndex > 0) {
          const selectedInput = cardProduct.querySelector('input[data-option-pr]:checked');
          const colorValue = selectedInput ? selectedInput.value : null;
          const skuValue = findSkuForColor(colorValue);
          applySkuValue(skuElement, skuValue, fallbackSku);
        } else {
          const firstSkuVariant = variants.find((variant) => variant && variant.sku);
          applySkuValue(skuElement, firstSkuVariant ? firstSkuVariant.sku : fallbackSku, fallbackSku);
        }
      };

      updateSku();

      if (Number.isInteger(colorIndex) && colorIndex > 0) {
        const colorInputs = cardProduct.querySelectorAll('input[data-option-pr]');
        colorInputs.forEach((input) => {
          input.addEventListener('change', updateSku);
        });
      }

      initializedSkuElements.add(skuElement);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initSkuElements());
  document.addEventListener('facet:render', () => {
    requestAnimationFrame(() => initSkuElements());
  });
  document.addEventListener('products:update', (event) => {
    const scope = event?.target instanceof Element ? event.target : document;
    requestAnimationFrame(() => initSkuElements(scope));
  });
  document.addEventListener('shopify:section:load', (event) => {
    if (event?.target) {
      initSkuElements(event.target);
    }
  });
  document.addEventListener('shopify:section:select', (event) => {
    if (event?.target) {
      initSkuElements(event.target);
    }
  });
})();


// Uds, total price on collection page
// We have to normalize by replacing dot by comma and comma by dot
function normalizeCurrency(baseAmount) {
  let t_moneyFormat = themeHDN.settings.currencyFormat;
  baseAmount = baseAmount.replace(/[,.]/g, function(match) {
    // If `,` is matched return `.`, if `.` matched return `,`
    return match === ',' ? '.' : '.';
  });

  return baseAmount;
}

function customFormatMoney(money, format) {
  let baseAmount = formatMoney(money, format);
  baseAmount = normalizeCurrency(baseAmount);

  return baseAmount;
}

function getTallaInputsByProductId(containerElement, productId, variantGroup = null) {
  let selector = `.hdt-talla-input[data-product-id='${productId}']`;
  if (variantGroup) {
    selector += `[data-variant-group='${variantGroup}']`;
  }
  const inputs = containerElement.querySelectorAll(selector);
  const byVariant = new Map();

  inputs.forEach((input) => {
    const variantId = input.getAttribute('data-variant-id') || `no-variant-${byVariant.size}`;
    const stored = byVariant.get(variantId);
    if (!stored) {
      byVariant.set(variantId, input);
      return;
    }

    const storedVisible = stored.offsetParent !== null;
    const inputVisible = input.offsetParent !== null;
    if (!storedVisible && inputVisible) {
      byVariant.set(variantId, input);
    }
  });

  return Array.from(byVariant.values());
}

function getStockValueForTallaInput(input) {
  if (!input) return null;

  const rotatedRow = input.closest('.hdt-talla-row');
  if (rotatedRow) {
    const stockCell = rotatedRow.querySelector('.hdt-talla-stock-value');
    if (stockCell) {
      const parsed = Number(stockCell.textContent.trim().replace(/[^0-9.-]/g, ''));
      return Number.isNaN(parsed) ? null : parsed;
    }
  }

  const wrapper = input.closest('.hdt-talla-input-wrapper');
  if (!wrapper) return null;
  const inputRow = wrapper.closest('tr');
  const table = wrapper.closest('table');
  const stockRow = table ? table.querySelector('tr.hdt-talla-stock') : null;
  if (!inputRow || !stockRow) return null;

  const inputCells = Array.from(inputRow.querySelectorAll('.hdt-talla-input-wrapper'));
  const index = inputCells.indexOf(wrapper);
  const stockCells = stockRow.querySelectorAll('.hdt-talla-stock-value');
  if (index === -1 || !stockCells[index]) return null;

  const parsed = Number(stockCells[index].textContent.trim().replace(/[^0-9.-]/g, ''));
  return Number.isNaN(parsed) ? null : parsed;
}

// Calculate totals across talla tables for a given product (optionally scoped to a variant group)
function calcTotalInfoByProductId(containerElement, productId, variantGroup = null) {
  let totalUds = 0;
  let totalPrice = 0;
  getTallaInputsByProductId(containerElement, productId, variantGroup).forEach(item => {
    if (item.value) {
      const count = Number(item.value);
      totalUds = totalUds + count;
      const price = item.getAttribute("data-price");
      if (price) {
        totalPrice = totalPrice + count * Number(price);
      }
    }
  });
  return { totalUds, totalPrice };
}

function updateDisplayedTotals(containerElement, productId) {
  const totalsAll = calcTotalInfoByProductId(containerElement, productId);

  const aggregatedUdsElements = containerElement.querySelectorAll(`.hdt-uds[data-product-id='${productId}']:not([data-variant-group])`);
  aggregatedUdsElements.forEach((el) => {
    el.textContent = totalsAll.totalUds;
  });

  const aggregatedPriceElements = containerElement.querySelectorAll(`.hdt-price-total[data-product-id='${productId}']:not([data-variant-group])`);
  aggregatedPriceElements.forEach((el) => {
    el.textContent = formatPrice(totalsAll.totalPrice);
  });

  const groupElements = containerElement.querySelectorAll(`.hdt-uds[data-product-id='${productId}'][data-variant-group]`);
  const groupHandles = new Set();
  groupElements.forEach((el) => {
    const handle = el.getAttribute('data-variant-group');
    if (handle) {
      groupHandles.add(handle);
    }
  });

  groupHandles.forEach((handle) => {
    const totalsForGroup = calcTotalInfoByProductId(containerElement, productId, handle);
    containerElement.querySelectorAll(`.hdt-uds[data-product-id='${productId}'][data-variant-group='${handle}']`).forEach((el) => {
      el.textContent = totalsForGroup.totalUds;
    });
    containerElement.querySelectorAll(`.hdt-price-total[data-product-id='${productId}'][data-variant-group='${handle}']`).forEach((el) => {
      el.textContent = formatPrice(totalsForGroup.totalPrice);
    });
  });

  return totalsAll;
}

function formatPrice(price) {
  const format = themeHDN.settings.currencyCodeEnabled ? themeHDN.settings.moneyWithCurrencyFormat : themeHDN.settings.currencyFormat;
  return customFormatMoney(price, format);
}

let tallaCartFetchPromise = null;

function fetchTallaCart() {
  if (!tallaCartFetchPromise) {
    tallaCartFetchPromise = fetch('/cart.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Cart request failed');
        }
        return response.json();
      })
      .catch((error) => {
        console.error('Failed to load cart for talla restore', error);
        return null;
      });
  }
  return tallaCartFetchPromise;
}

function setTallaCartCache(cartData) {
  if (cartData && typeof cartData === 'object') {
    tallaCartFetchPromise = Promise.resolve(cartData);
  } else {
    tallaCartFetchPromise = null;
  }
}

function restoreTallaQuantitiesFromCart(scope = document) {
  if (!scope || typeof scope.querySelectorAll !== 'function') return;

  const inputs = scope.querySelectorAll('.hdt-talla-input[data-variant-id][data-product-id]');
  if (!inputs.length) return;

  fetchTallaCart().then((cart) => {
    if (!cart || !Array.isArray(cart.items)) {
      inputs.forEach((input) => {
        if (!input.dataset.lastQuantity) {
          input.dataset.lastQuantity = input.value || "0";
        }
      });
      return;
    }

    const quantitiesByVariant = new Map();
    cart.items.forEach((item) => {
      if (!item || !item.variant_id) return;
      const quantity = Number(item.quantity) || 0;
      quantitiesByVariant.set(String(item.variant_id), quantity);
    });

    const productsToRefresh = new Set();

    inputs.forEach((input) => {
      const variantId = input.getAttribute('data-variant-id');
      const productId = input.getAttribute('data-product-id');
      if (!variantId || !productId) return;

      if (input.dataset.pendingSync === 'true') {
        productsToRefresh.add(productId);
        return;
      }

      const targetQuantity = quantitiesByVariant.get(String(variantId)) || 0;
      const currentQuantity = Number(input.value) || 0;
      if (currentQuantity !== targetQuantity) {
        input.value = targetQuantity;
        productsToRefresh.add(productId);
      } else if (targetQuantity > 0) {
        productsToRefresh.add(productId);
      }

      input.dataset.lastQuantity = String(targetQuantity);

      const price = Number(input.getAttribute('data-price')) || 0;
      const variantTotalSelectors = `.hdt-price-total-variant-wrapper[data-pv-id='${productId}-${variantId}'] > .hdt-price-total-variant, td.hdt-talla-price-col.hdt-talla-price-col--variant[data-pv-id='${productId}-${variantId}'] > .hdt-price-total-variant`;
      scope.querySelectorAll(variantTotalSelectors).forEach((variantTotal) => {
        variantTotal.textContent = formatPrice(price * targetQuantity);
      });
    });

    productsToRefresh.forEach((productId) => {
      updateDisplayedTotals(scope, productId);
      updateAtcButtonState(scope, productId);
    });
  });
}

function rotateTallaTables(container = document) {
  const tables = container.querySelectorAll('table.hdt-talla:not([data-rotated])');
  tables.forEach((table) => {
    const headerRow = table.querySelector('tbody > tr');
    const inputRow = table.querySelector('tr.hdt-talla-inputs');
    const stockRow = table.querySelector('tr.hdt-talla-stock');
    if (!headerRow || !inputRow || !stockRow) {
      return;
    }

    const sizeHeaders = Array.from(headerRow.querySelectorAll('th[scope="col"]')).filter((th) => !th.classList.contains('hdt-uds-header') && !th.classList.contains('hdt-price-header'));
    const inputCells = Array.from(inputRow.querySelectorAll('td.hdt-talla-input-wrapper'));
    const stockCells = Array.from(stockRow.querySelectorAll('td.hdt-talla-stock-value'));

    if (!sizeHeaders.length || inputCells.length !== sizeHeaders.length || stockCells.length !== sizeHeaders.length) {
      return;
    }

    const tallaLabel = headerRow.querySelector('.hdt-talla-label-col--heading');
    const pedidoLabel = inputRow.querySelector('.hdt-talla-label-col--pedido');
    const stockLabel = stockRow.querySelector('.hdt-talla-label-col--stock');
    const udsHeader = headerRow.querySelector('.hdt-uds-header');
    const priceHeader = headerRow.querySelector('.hdt-price-header');

    const udsCell = inputRow.querySelector('td.hdt-talla-total-uds');
    const priceCell = inputRow.querySelector('td.hdt-talla-price-col:not(.hdt-talla-placeholder)');
    const placeholders = Array.from(stockRow.querySelectorAll('td.hdt-talla-placeholder'));

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');

    [
      { label: tallaLabel?.textContent?.trim() || 'Talla', className: 'hdt-talla-label-col hdt-talla-label-col--heading' },
      { label: pedidoLabel?.textContent?.trim() || 'Pedido', className: 'hdt-talla-label-col hdt-talla-label-col--pedido' },
      { label: stockLabel?.textContent?.trim() || 'Stock', className: 'hdt-talla-label-col hdt-talla-label-col--stock' },
    ].forEach(({ label, className }) => {
      const th = document.createElement('th');
      th.scope = 'col';
      if (className) th.className = className;
      th.textContent = label;
      headRow.appendChild(th);
    });

    thead.appendChild(headRow);

    const tbody = document.createElement('tbody');

    sizeHeaders.forEach((sizeHeader, index) => {
      const sizeRow = document.createElement('tr');
      sizeRow.className = 'hdt-talla-row';

      const sizeTh = document.createElement('th');
      sizeTh.scope = 'row';
      sizeTh.className = 'hdt-talla-size-label';
      sizeTh.textContent = sizeHeader.textContent.trim();
      sizeRow.appendChild(sizeTh);

      const inputCell = inputCells[index];
      sizeRow.appendChild(inputCell || document.createElement('td'));

      const stockCell = stockCells[index];
      sizeRow.appendChild(stockCell || document.createElement('td'));

      tbody.appendChild(sizeRow);
    });

    const udsRow = document.createElement('tr');
    udsRow.className = 'hdt-talla-summary hdt-talla-summary--total';

    const udsLabelCell = document.createElement('th');
    udsLabelCell.scope = 'row';
    udsLabelCell.className = 'hdt-uds-header';
    udsLabelCell.textContent = udsHeader?.textContent?.trim() || 'Total Uds';
    udsRow.appendChild(udsLabelCell);
    udsRow.appendChild(udsCell || document.createElement('td'));

    const udsPlaceholder = placeholders.shift() || document.createElement('td');
    udsPlaceholder.classList.add('hdt-talla-price-col', 'hdt-talla-placeholder');
    udsPlaceholder.setAttribute('aria-hidden', 'true');
    udsRow.appendChild(udsPlaceholder);
    tbody.appendChild(udsRow);

    const priceRow = document.createElement('tr');
    priceRow.className = 'hdt-talla-summary hdt-talla-summary--price';

    const priceLabelCell = document.createElement('th');
    priceLabelCell.scope = 'row';
    priceLabelCell.className = 'hdt-price-header';
    priceLabelCell.textContent = priceHeader?.textContent?.trim() || 'Precio total';
    priceRow.appendChild(priceLabelCell);
    priceRow.appendChild(priceCell || document.createElement('td'));

    const pricePlaceholder = placeholders.shift() || document.createElement('td');
    pricePlaceholder.classList.add('hdt-talla-price-col', 'hdt-talla-placeholder');
    pricePlaceholder.setAttribute('aria-hidden', 'true');
    priceRow.appendChild(pricePlaceholder);
    tbody.appendChild(priceRow);

    while (table.firstChild) {
      table.removeChild(table.firstChild);
    }

    table.appendChild(thead);
    table.appendChild(tbody);
    table.dataset.rotated = 'true';
  });
}

function handleTallaInputChange(containerElement) {
  containerElement.querySelectorAll(".hdt-talla-input").forEach(element => {
    if (element.dataset.lastQuantity === undefined) {
      element.dataset.lastQuantity = element.value || "0";
    }

    element.addEventListener("blur", function() {
      const qty = parseInt(this.value);
      const minQty = parseInt(this.getAttribute("min"));
      const maxQty = parseInt(this.getAttribute("max"));

      if (isNaN(qty)) {
        this.value = 0;
      } else if (qty < minQty && qty > 0) {
        this.value = minQty;
      }

      const productId = this.getAttribute("data-product-id");
      const variantId = this.getAttribute("data-variant-id");

      const errorWrapper = productId ? containerElement.querySelector(`.hdt-form__message-wrapper[data-product-id='${productId}']`) : null;
      const clearError = () => {
        if (errorWrapper && !errorWrapper.hidden) {
          const span = errorWrapper.querySelector(".hdt-error-message");
          if (span) span.textContent = "";
          errorWrapper.hidden = true;
        }
      };
      const showError = (message) => {
        if (!errorWrapper) return;
        const span = errorWrapper.querySelector(".hdt-error-message");
        if (span) span.textContent = message;
        errorWrapper.hidden = false;
      };

      const stockValue = getStockValueForTallaInput(this);
      const inventoryPolicy = this.getAttribute('data-inventory-policy') || '';
      const inventoryManagement = this.getAttribute('data-inventory-management') || '';
      const enforceStock = inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';
      if (!isNaN(qty) && enforceStock && stockValue !== null && qty > stockValue) {
        showError("Tu pedido supera nuestro stock, añadimos la cantidad disponible");
        const revertValue = this.dataset.lastQuantity !== undefined ? this.dataset.lastQuantity : (stockValue > 0 ? String(stockValue) : "0");
        this.value = revertValue;
        if (productId) {
          updateDisplayedTotals(containerElement, productId);
          updateAtcButtonState(containerElement, productId);
        }
        return;
      } else if (!isNaN(qty)) {
        clearError();
      }

      if (!productId || !variantId) {
        if (productId) {
          updateAtcButtonState(containerElement, productId);
        }
        return;
      }

      const previousQty = Number(this.dataset.lastQuantity ?? 0);
      const currentQty = Number(this.value || 0);

      // Update variant total price
      let variantTotalPriceElement = containerElement.querySelector(`.hdt-price-total-variant-wrapper[data-pv-id='${productId}-${variantId}'] > .hdt-price-total-variant, td.hdt-talla-price-col.hdt-talla-price-col--variant[data-pv-id='${productId}-${variantId}'] > .hdt-price-total-variant`);
      if (variantTotalPriceElement) {
        const price = this.getAttribute("data-price");
        const qtyForVariant = Number(this.value);
        if (price) {
          const total = formatPrice(price * qtyForVariant);
          variantTotalPriceElement.textContent = total;
        }
      }

      updateDisplayedTotals(containerElement, productId);

      // Update Add to Cart button state based on total quantity
      updateAtcButtonState(containerElement, productId);

      if (previousQty !== currentQty) {
        const variantIdForSync = this.getAttribute("data-variant-id");
        const pendingInputs = (variantIdForSync && productId)
          ? Array.from(document.querySelectorAll(`.hdt-talla-input[data-product-id='${productId}'][data-variant-id='${variantIdForSync}']`))
          : [this];
        pendingInputs.forEach((inputEl) => {
          inputEl.dataset.pendingSync = 'true';
        });
        const clearPending = () => {
          pendingInputs.forEach((inputEl) => {
            delete inputEl.dataset.pendingSync;
          });
        };
        const groupContainer = this.closest('[data-variant-group]');
        const variantGroup = groupContainer ? groupContainer.getAttribute('data-variant-group') : null;
        const atcInGroup = groupContainer ? groupContainer.querySelector('.hdt-card-product__atc') : null;
        syncProductCart(containerElement, productId, { trigger: "blur", variantGroup, atcElement: atcInGroup })
          .then(clearPending)
          .catch(clearPending);
      }

    });

    // Also listen for input events for real-time updates
    element.addEventListener("input", function() {
      const productId = this.getAttribute("data-product-id");
      updateAtcButtonState(containerElement, productId);
    });
  })
}

// Function to update Add to Cart button state based on quantities
function updateAtcButtonState(containerElement, productId) {
  const atcButtons = containerElement.querySelectorAll(`.hdt-card-product__atc[data-product-id='${productId}']`);
  if (!atcButtons.length) return;

  atcButtons.forEach(function(atcButton) {
    const variantGroupContainer = atcButton.closest('[data-variant-group]');
    const variantGroup = variantGroupContainer ? variantGroupContainer.getAttribute('data-variant-group') : null;

    let selector = `.hdt-talla-input[data-product-id='${productId}']`;
    if (variantGroup) {
      selector += `[data-variant-group='${variantGroup}']`;
    }

    let relevantInputs = Array.from(containerElement.querySelectorAll(selector));

    if (!relevantInputs.length && variantGroup) {
      const scopedContainer = variantGroupContainer || atcButton.closest(`[data-product-id='${productId}']`);
      if (scopedContainer) {
        relevantInputs = Array.from(scopedContainer.querySelectorAll(`.hdt-talla-input[data-product-id='${productId}']`));
      }
    }

    if (!relevantInputs.length && !variantGroup) {
      relevantInputs = Array.from(containerElement.querySelectorAll(`.hdt-talla-input[data-product-id='${productId}']`));
    }

    const hasQuantity = relevantInputs.some((input) => {
      const qty = parseInt(input.value, 10) || 0;
      return qty > 0;
    });

    const atcTextElement = atcButton.querySelector(".hdt-btn-atc_text");
    const fallbackText = atcTextElement ? atcTextElement.textContent : "";
    const enabledText = atcButton.dataset.atcEnabledText || fallbackText;
    const disabledText = atcButton.dataset.atcDisabledText || fallbackText || enabledText;

    if (hasQuantity) {
      atcButton.removeAttribute("disabled");
      atcButton.removeAttribute("aria-disabled");
      if (atcTextElement && enabledText && atcTextElement.textContent !== enabledText) {
        atcTextElement.textContent = enabledText;
      }
    } else {
      atcButton.setAttribute("disabled", "disabled");
      atcButton.setAttribute("aria-disabled", "true");
      if (atcTextElement && disabledText && atcTextElement.textContent !== disabledText) {
        atcTextElement.textContent = disabledText;
      }
    }
  });
}

const productCartSyncQueue = new Map();

function enqueueProductCartSync(productId, runner) {
  const previous = productCartSyncQueue.get(productId) || Promise.resolve();
  const next = previous.catch(() => {}).then(() => runner());
  productCartSyncQueue.set(productId, next);
  return next.finally(() => {
    if (productCartSyncQueue.get(productId) === next) {
      productCartSyncQueue.delete(productId);
    }
  });
}

function syncProductCart(containerElement, productId, options = {}) {
  return enqueueProductCartSync(productId, async () => {
    let button;
    let shouldDisableButton = false;
    let loaderActive = false;
    const trigger = options.trigger || 'manual';
    const variantGroup = options.variantGroup || null;
    let visibleInputs = [];
    let allInputs = [];
    const attemptedInputs = new Set();

    try {
      try {
        window.hdtTallaSync &&
          window.hdtTallaSync[productId] &&
          typeof window.hdtTallaSync[productId].sync === 'function' &&
          window.hdtTallaSync[productId].sync();
      } catch (e) { console.error('hdtTallaSync.sync() threw an error', e); }

      visibleInputs = getTallaInputsByProductId(containerElement, productId, variantGroup);
      let allSelector = `.hdt-talla-input[data-product-id='${productId}']`;
      if (variantGroup) allSelector += `[data-variant-group='${variantGroup}']`;
      allInputs = containerElement.querySelectorAll(allSelector);

      if (!visibleInputs.length && !allInputs.length) {
        return null;
      }

      if (trigger === 'button') {
        const hasQuantity = visibleInputs.some((input) => (Number(input.value) || 0) > 0);
        if (!hasQuantity) {
          return null;
        }
      }

      if (options.atcElement) {
        button = options.atcElement;
      } else if (variantGroup) {
        const group = containerElement.querySelector(`[data-product-id='${productId}'][data-variant-group='${variantGroup}']`);
        button = group ? group.querySelector(`.hdt-card-product__atc[data-product-id='${productId}']`) : null;
      }
      if (!button) {
        button = containerElement.querySelector(`.hdt-card-product__atc[data-product-id='${productId}']`);
      }
      shouldDisableButton = options.disableButton !== false && !!button;

      if (shouldDisableButton) {
        button.setAttribute("disabled", "disabled");
        button.setAttribute("aria-busy", "true");
      }

      const sections = ['cart-drawer'];
      const errorWrapper = containerElement.querySelector(`.hdt-form__message-wrapper[data-product-id='${productId}']`);
      if (errorWrapper) errorWrapper.hidden = true;

      document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 }));
      document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: !0, detail: { sections } }));
      loaderActive = true;

      const cartResponse = await fetch('/cart.json');
      const cartData = await cartResponse.json();

      const isProductPage = window.location.pathname.includes('/products/');
      const updates = {};
      const itemsToAdd = [];

      visibleInputs.forEach((input) => {
        const variantId = parseInt(input.getAttribute("data-variant-id"), 10);
        if (!variantId) return;

        const qty = Number(input.value) || 0;
        if (qty > 0) {
          attemptedInputs.add(input);
        }
        const price = Number(input.getAttribute("data-price")) || 0;
        const listPrice = input.getAttribute("data-list-price");
        const existingItem = cartData.items?.find(cartItem => cartItem.variant_id === variantId);

        if (existingItem) {
          updates[variantId] = qty;
        } else if (qty > 0) {
          if (isProductPage) {
            itemsToAdd.push({ id: variantId, quantity: qty, properties: { "_custom_price": price, "PVP": listPrice } });
          } else {
            itemsToAdd.push({ id: variantId, quantity: qty });
          }
        }
      });

      if (!Object.keys(updates).length && !itemsToAdd.length) {
        document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 }));
        loaderActive = false;
        allInputs.forEach((input) => {
          input.dataset.lastQuantity = input.value;
        });
        setTallaCartCache(cartData);
        return cartData;
      }

      let finalResponse = null;

      if (Object.keys(updates).length > 0) {
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates, sections: sections.join(",") })
        });

        if (!updateResponse.ok) {
          throw await updateResponse.json();
        }

        finalResponse = await updateResponse.json();
      }

      if (itemsToAdd.length > 0) {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: itemsToAdd, sections: sections.join(",") })
        });

        if (!addResponse.ok) {
          throw await addResponse.json();
        }

        finalResponse = await addResponse.json();
      }

      document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 }));
      loaderActive = false;

      const latestCartResponse = await fetch('/cart.json');
      const latestCartData = await latestCartResponse.json();

      if (finalResponse && finalResponse.sections) {
        latestCartData.sections = finalResponse.sections;
      }

      setTallaCartCache(latestCartData);

      // Proactively refresh mini cart drawer contents so it reflects new talla quantities
      try {
        const cartDrawer = document.querySelector('hdt-cart-drawer');
        if (cartDrawer) {
          // Update data-count immediately
          if (typeof latestCartData.item_count !== 'undefined') {
            cartDrawer.setAttribute('data-count', latestCartData.item_count || 0);
          }

          const drawerSectionHTML = latestCartData.sections && latestCartData.sections['cart-drawer']
            ? latestCartData.sections['cart-drawer']
            : null;

          const updateDrawerFromHTML = (html) => {
            if (!html) return;
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(html, 'text/html');
            const newCartContent = newDoc.querySelector('hdt-cart-drawer');
            if (newCartContent && cartDrawer) {
              const existingDialog = cartDrawer.querySelector('#CartDrawer') || cartDrawer.querySelector('dialog');
              const newDialog = newCartContent.querySelector('#CartDrawer') || newCartContent.querySelector('dialog');
              if (existingDialog && newDialog) {
                existingDialog.innerHTML = newDialog.innerHTML;
              } else if (existingDialog) {
                existingDialog.innerHTML = newCartContent.innerHTML;
              } else {
                cartDrawer.innerHTML = newCartContent.innerHTML;
              }
            }
          };

          if (drawerSectionHTML) {
            updateDrawerFromHTML(drawerSectionHTML);
          } else {
            // Fallback: fetch the section fresh from server
            try {
              const resp = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
              if (resp.ok) {
                const html = await resp.text();
                updateDrawerFromHTML(html);
              }
            } catch (e) { console.error('Failed to fetch cart-drawer section in talla flow', e); }
          }
        }
      } catch (e) { console.error('Error while refreshing mini cart after talla update', e); }

      const isCollectionPage = window.location.pathname.includes('/collections/');
      const preventDrawer = isCollectionPage || isProductPage;
      const eventTarget = button || containerElement;

      if (finalResponse) {
        eventTarget.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: !0,
          detail: {
            items: finalResponse.hasOwnProperty("items") ? finalResponse.items : [finalResponse],
            cart: latestCartData,
            preventCartDrawer: preventDrawer
          }
        }));

        document.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: !0,
          detail: {
            baseEvent: "variant:add",
            cart: latestCartData,
            preventCartDrawer: preventDrawer
          }
        }));
      }

      allInputs.forEach((input) => {
        input.dataset.lastQuantity = input.value;
        delete input.dataset.pendingSync;
      });

      return latestCartData;
    } catch (error) {
      console.error('Error:', error);
      setTallaCartCache(null);
      const errorWrapper = containerElement.querySelector(`.hdt-form__message-wrapper[data-product-id='${productId}']`);
      let errorText = 'No se pudo añadir al carrito.';
      if (error) {
        if (typeof error === 'string') errorText = error;
        else if (error.description) errorText = error.description;
        else if (error.message) errorText = error.message;
        else if (error.errors) errorText = Array.isArray(error.errors) ? error.errors.join(', ') : JSON.stringify(error.errors);
      }
      if (errorWrapper) {
        const span = errorWrapper.querySelector('.hdt-error-message');
        if (span) span.textContent = errorText;
        errorWrapper.hidden = false;
      }
      attemptedInputs.forEach((input) => {
        if (!input || !input.isConnected) return;
        if ((Number(input.value) || 0) <= 0) return;

        const stock = getStockValueForTallaInput(input);
        if (stock !== null && stock > 0) {
          delete input.dataset.pendingSync;
          return;
        }

        input.value = 0;
        input.dataset.lastQuantity = '0';
        input.dispatchEvent(new Event("blur"));
        delete input.dataset.pendingSync;
      });
      if (loaderActive) {
        document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 }));
        loaderActive = false;
      }
      document.dispatchEvent(new CustomEvent("cart:add:error", { bubbles: !0, detail: { error: errorText } }));
      throw error;
    } finally {
      if (button && shouldDisableButton) {
        button.removeAttribute("disabled");
        button.removeAttribute("aria-busy");
      }
      updateAtcButtonState(containerElement, productId);
    }
  });
}

// ATC for collection and product pages
function handleAtc(containerElement) {
  containerElement.querySelectorAll(".hdt-card-product__atc").forEach(function(atcElement) {
    atcElement.addEventListener("click", function() {
      const isProductPage = window.location.pathname.includes('/products/');

      if (isProductPage && !atcElement.classList.contains('hdt-card-product__atc')) {
        return;
      }

      const productId = atcElement.getAttribute("data-product-id");
      if (!productId) {
        return;
      }

      const groupContainer = atcElement.closest('[data-variant-group]');
      const variantGroup = groupContainer ? groupContainer.getAttribute('data-variant-group') : null;

      syncProductCart(containerElement, productId, { atcElement, trigger: 'button', variantGroup }).catch(() => {});
    });
  });
}

// Clear all talla inputs for a product within a given container
function handleClear(containerElement) {
  containerElement.querySelectorAll(".hdt-card-product__clear").forEach(function(clearBtn) {
    const productId = clearBtn.getAttribute("data-product-id");
    clearBtn.addEventListener("click", function() {
      if (!productId) return;

      // Determine scope (variant group) if present
      const groupContainer = clearBtn.closest('[data-variant-group]');
      const variantGroup = groupContainer ? groupContainer.getAttribute('data-variant-group') : null;
      const colorKey = clearBtn.getAttribute('data-color-key') || (groupContainer && groupContainer.getAttribute('data-color-key')) || null;

      // Build selector to target only inputs in this group
      let selector = `.hdt-talla-input[data-product-id='${productId}']`;
      if (variantGroup) selector += `[data-variant-group='${variantGroup}']`;
      else if (colorKey) selector += `[data-color-key='${CSS.escape(colorKey)}']`;

      const inputs = containerElement.querySelectorAll(selector);

      inputs.forEach((input) => {
        input.value = 0;
        // Reuse existing logic that updates totals and clamps values
        input.dispatchEvent(new Event("blur"));
      });

      // Ensure totals are updated even if all were already zero
      updateDisplayedTotals(containerElement, productId);

      // Hide any previous error message for this product
      const errorWrapper = containerElement.querySelector(`.hdt-form__message-wrapper[data-product-id='${productId}']`);
      if (errorWrapper) errorWrapper.hidden = true;

      // Update Add to Cart button state
      updateAtcButtonState(containerElement, productId);
    });
  });
}

class TallaAtcTr extends HTMLTableRowElement {
  constructor() {
    super();
  }
  connectedCallback() {
    //handleTallaInputChange(this);
    //handleAtc(this);
    //handleClear(this);
    // Initialize ATC disabled state for newly inserted rows
    try {
      this.querySelectorAll('.hdt-card-product__atc').forEach((btn) => {
        const productId = btn.getAttribute('data-product-id');
        if (productId) updateAtcButtonState(this, productId);
      });
    } catch (e) {
      console.error(e);
    }
  }
}

customElements.define("hdt-talla-atc-tr", TallaAtcTr, { extends: "tr" });

class TallaAtc extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    //rotateTallaTables(this);
    //handleTallaInputChange(this);
    //handleAtc(this);
    //handleClear(this);
    // Initialize ATC disabled state for newly inserted blocks
    try {
      this.querySelectorAll('.hdt-card-product__atc').forEach((btn) => {
        const productId = btn.getAttribute('data-product-id');
        if (productId) updateAtcButtonState(this, productId);
      });
    } catch (e) {
      console.error(e);
    }
  }
}

customElements.define("hdt-talla-atc", TallaAtc);

function setCollectionVariantVisibility(button, expand) {
  if (!button) return;

  const productId = button.getAttribute("data-product-id");
  const table = button.closest(".hdt-collection-products-table");
  const primaryRow = button.closest(".hdt-collection-product-row");

  button.setAttribute("aria-expanded", String(expand));
  if (primaryRow) {
    primaryRow.classList.toggle("hdt-collection-product-row--open", expand);
  }

  if (table && productId) {
    table.querySelectorAll(`tr.hdt-collection-product-row--variant[data-parent-product='${productId}']`).forEach((row) => {
      row.classList.toggle("hdt-collection-product-row--hidden", !expand);
    });
  }
}

function handleCollectionVariantToggle(button) {
  if (!button) return;
  const isExpanded = button.getAttribute("aria-expanded") === "true";
  setCollectionVariantVisibility(button, !isExpanded);
}

function initCollectionVariantToggles(scope = document) {
  if (!scope || typeof scope.querySelectorAll !== "function") return;

  const toggleButtons = scope.querySelectorAll(".hdt-card-product__variants-toggle");
  toggleButtons.forEach((button) => {
    if (button.dataset.variantToggleInit === "true") return;
    button.dataset.variantToggleInit = "true";

    const isExpanded = button.getAttribute("aria-expanded") === "true";
    setCollectionVariantVisibility(button, isExpanded);
  });
}

document.addEventListener('shopify:section:load', (event) => {
  // rotateTallaTables(event.target);
  // restoreTallaQuantitiesFromCart(event.target);
  initCollectionVariantToggles(event.target);
});

document.addEventListener('click', (event) => {
  const button = event.target && event.target.closest?.('.hdt-card-product__variants-toggle');
  if (!button) return;
  handleCollectionVariantToggle(button);
});

document.addEventListener('DOMContentLoaded', () => {
  // restoreTallaQuantitiesFromCart(document);
  initCollectionVariantToggles(document);
});

window.addEventListener('load', () => {
  // restoreTallaQuantitiesFromCart(document);
});

// Sync talla inputs' variant mapping with selected color on product pages
document.addEventListener('DOMContentLoaded', function() {
  try {
    // Scope to product page only
    const isProductPage = window.location.pathname.includes('/products/');
    if (!isProductPage) return;

    // Find all variant pickers on page that carry selected-variant
    const pickers = document.querySelectorAll('hdt-variant-picker[handle][form]');
    if (!pickers.length) return;

    pickers.forEach((picker) => {
      const formAttr = picker.getAttribute('form') || '';
      const handle = picker.getAttribute('handle');
      const selVariantStr = picker.getAttribute('selected-variant');
      const productIdMatch = formAttr.match(/(\d+)$/);
      const productId = productIdMatch ? productIdMatch[1] : null;
      if (!handle || !productId) return;

      // Fetch product JSON once per picker
      fetch(`${Shopify.routes.root}products/${handle}.js`).then(r => r.json()).then((product) => {
        if (!product || !Array.isArray(product.variants)) return;

        const optionNamesRaw = (product.options || []).map(n => (typeof n === 'string' ? n : (n && n.name) || '')).map(s => s || '');
        const optionNames = optionNamesRaw.map(s => s.toLowerCase());
        let sizeIdx = optionNames.indexOf('talla');
        if (sizeIdx === -1) sizeIdx = optionNames.indexOf('size');
        let colorIdx = -1;
        ['color', 'colour', 'colores'].some((key) => { const i = optionNames.indexOf(key); if (i !== -1) { colorIdx = i; return true; } return false; });
        if (sizeIdx === -1 || colorIdx === -1) return; // Not a color/size product

        const getSelectedVariant = () => {
          const idAttr = picker.getAttribute('selected-variant');
          if (idAttr) {
            const id = parseInt(idAttr, 10);
            const byId = product.variants.find(v => v.id === id);
            if (byId) return byId;
          }
          // Fallback: resolve via option values read from DOM
          const colorVal = getOptionValueByIndex(picker, colorIdx, optionNamesRaw[colorIdx]);
          const sizeVal = getOptionValueByIndex(picker, sizeIdx, optionNamesRaw[sizeIdx]);
          if (colorVal || sizeVal) {
            const found = product.variants.find(v => {
              const okColor = colorVal ? v[`option${colorIdx + 1}`] == colorVal : true;
              const okSize = sizeVal ? v[`option${sizeIdx + 1}`] == sizeVal : true;
              return okColor && okSize;
            });
            if (found) return found;
          }
          return null;
        };

        const inferSizeFromDom = (input) => {
          // Prefer explicit data-size if present
          const ds = input.getAttribute('data-size');
          if (ds) return ds;
          // Fallback: derive from table header cell at the same column index
          const td = input.closest('td');
          if (!td) return null;
          const table = td.closest('table');
          if (!table) return null;
          const headerRow = table.querySelector('tbody > tr:first-child, thead > tr:first-child, tr:first-child');
          if (!headerRow) return null;
          const cells = Array.from(headerRow.children);
          const colIdx = (typeof td.cellIndex === 'number' && td.cellIndex >= 0) ? td.cellIndex : cells.indexOf(td);
          if (colIdx < 0 || colIdx >= cells.length) return null;
          const txt = (cells[colIdx].textContent || '').trim();
          return txt || null;
        };

        function getOptionValueByIndex(root, idx, name) {
          if (!root) return null;
          // 1) hidden input: option{idx+1}
          const hidden = root.querySelector(`input[is-value][name="option${idx + 1}"]`);
          if (hidden && typeof hidden.value === 'string' && hidden.value.length) return hidden.value;
          // 2) radio inputs by option name
          if (name) {
            const radioChecked = root.querySelector(`input[is-value][name="${CSS.escape(name)}"]:checked`);
            if (radioChecked && typeof radioChecked.value === 'string' && radioChecked.value.length) return radioChecked.value;
          }
          // 3) dropdown buttons inside the fieldset for this index
          const fieldset = root.querySelector(`fieldset[data-index="${idx}"]`);
          if (fieldset) {
            const btn = fieldset.querySelector('button[role="option"][aria-selected="true"]');
            if (btn && btn.hasAttribute('value')) return btn.getAttribute('value');
          }
          return null;
        }

        const variantMapCache = new WeakMap();

        const parseVariantMap = (element) => {
          if (!element) return null;
          if (variantMapCache.has(element)) return variantMapCache.get(element);
          const raw = element.getAttribute('data-variant-map');
          if (!raw) {
            variantMapCache.set(element, null);
            return null;
          }
          try {
            const parsed = JSON.parse(raw);
            variantMapCache.set(element, parsed);
            return parsed;
          } catch (err) {
            variantMapCache.set(element, null);
            return null;
          }
        };

        const getVariantDataForColor = (element, color) => {
          if (!element || !color) return null;
          const map = parseVariantMap(element);
          if (!map || typeof map !== 'object') return null;
          const key = typeof color === 'string' ? color : String(color || '');
          const entry = map[key] || map[key.trim?.()] || null;
          if (!entry || typeof entry !== 'object') return null;
          const quantityRule = entry.quantity_rule || {};
          return {
            id: entry.id,
            price: entry.price,
            stock: typeof entry.stock === 'number' ? entry.stock : null,
            available: typeof entry.available === 'boolean' ? entry.available : null,
            inventory_management: entry.inventory_management,
            inventory_policy: entry.inventory_policy,
            quantity_rule: {
              min: typeof quantityRule.min === 'number' ? quantityRule.min : null,
              max: typeof quantityRule.max === 'number' ? quantityRule.max : null,
              increment: typeof quantityRule.increment === 'number' ? quantityRule.increment : null,
            },
          };
        };

        const getStockCellForInput = (input) => {
          if (!input) return null;
          const rotatedRow = input.closest('.hdt-talla-row');
          if (rotatedRow) return rotatedRow.querySelector('.hdt-talla-stock-value');
          const wrapper = input.closest('.hdt-talla-input-wrapper');
          if (!wrapper) return null;
          const inputRow = wrapper.closest('tr');
          const table = inputRow ? inputRow.closest('table') : null;
          const stockRow = table ? table.querySelector('tr.hdt-talla-stock') : null;
          if (!stockRow || !inputRow) return null;
          const wrappers = Array.from(inputRow.querySelectorAll('.hdt-talla-input-wrapper'));
          const index = wrappers.indexOf(wrapper);
          if (index === -1) return null;
          const stockCells = stockRow.querySelectorAll('td.hdt-talla-stock-value');
          return stockCells[index] || null;
        };

        const updateStockCell = (cell, variant) => {
          if (!cell) return;
          if (!variant) {
            cell.textContent = '--';
            return;
          }
          const stockValue = (typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : (typeof variant.stock === 'number' ? variant.stock : null);
          const managesInventory = variant.inventory_management === 'shopify';
          const tracksInventory = managesInventory && variant.inventory_policy !== 'continue';
          if (tracksInventory && typeof stockValue === 'number') {
            cell.textContent = Math.max(0, stockValue);
            return;
          }
          if (typeof stockValue === 'number' && stockValue > 0) {
            cell.textContent = stockValue;
            return;
          }
          cell.textContent = '--';
        };

        const setInventoryMeta = (input, variant) => {
          if (!input) return;
          if (variant) {
            if (variant.inventory_policy) input.setAttribute('data-inventory-policy', variant.inventory_policy);
            else input.removeAttribute('data-inventory-policy');
            if (variant.inventory_management) input.setAttribute('data-inventory-management', variant.inventory_management);
            else input.removeAttribute('data-inventory-management');
            const qtyValue = (typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : (typeof variant.stock === 'number' ? variant.stock : null);
            if (qtyValue !== null && qtyValue !== undefined) input.setAttribute('data-inventory-quantity', qtyValue);
            else input.removeAttribute('data-inventory-quantity');
            if (typeof variant.available === 'boolean') input.setAttribute('data-variant-available', variant.available ? 'true' : 'false');
            else input.removeAttribute('data-variant-available');
          } else {
            input.removeAttribute('data-inventory-policy');
            input.removeAttribute('data-inventory-management');
            input.removeAttribute('data-inventory-quantity');
            input.removeAttribute('data-variant-available');
          }
        };

        const updateQuantityLimits = (input, variant) => {
          if (!input) return;
          if (!variant) {
            input.removeAttribute('max');
            input.removeAttribute('min');
            input.removeAttribute('step');
            return;
          }

          const quantityRule = variant.quantity_rule || {};
          if (typeof quantityRule.min === 'number') {
            input.setAttribute('min', quantityRule.min);
          } else {
            input.removeAttribute('min');
          }

          if (typeof quantityRule.increment === 'number' && quantityRule.increment > 0) {
            input.setAttribute('step', quantityRule.increment);
          } else {
            input.removeAttribute('step');
          }

          let maxAttr = null;
          if (typeof quantityRule.max === 'number' && quantityRule.max > 0) {
            maxAttr = quantityRule.max;
          }

          const tracksInventory = variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';
          if (tracksInventory && typeof variant.inventory_quantity === 'number') {
            const inventoryQty = Number(variant.inventory_quantity);
            if (inventoryQty > 0) {
              const inventoryMax = Math.max(0, inventoryQty);
              maxAttr = typeof maxAttr === 'number' ? Math.min(maxAttr, inventoryMax) : inventoryMax;
            }
          }

          if (typeof maxAttr === 'number' && Number.isFinite(maxAttr) && maxAttr > 0) {
            input.setAttribute('max', maxAttr);
          } else {
            input.removeAttribute('max');
          }
        };

        const recalcTotals = () => {
          try {
            updateDisplayedTotals(document, productId);
            updateAtcButtonState(document, productId);
          } catch (e) { /* noop */ }
        };

        const syncTallaForSelectedColor = () => {
          const selected = getSelectedVariant();
          // Resolve selected color robustly
          let selectedColor = getOptionValueByIndex(picker, colorIdx, optionNamesRaw[colorIdx]);
          if (!selectedColor && selected) selectedColor = selected[`option${colorIdx + 1}`];
          if (!selectedColor) return;

          const inputs = document.querySelectorAll(`.hdt-talla-input[data-product-id='${productId}']`);
          inputs.forEach((input) => {
            const sizeVal = inferSizeFromDom(input);
            if (!sizeVal) return;
            const stockCell = getStockCellForInput(input);
            let match = null;
            let variantData = getVariantDataForColor(input, selectedColor);
            if (!variantData && stockCell) {
              variantData = getVariantDataForColor(stockCell, selectedColor);
            }
            if (variantData && variantData.id) {
              const stockValue = typeof variantData.stock === 'number' ? variantData.stock : null;
              const quantityRule = variantData.quantity_rule || {};
              match = {
                id: variantData.id,
                price: variantData.price,
                available: typeof variantData.available === 'boolean'
                  ? variantData.available
                  : (typeof stockValue === 'number' ? stockValue > 0 : true),
                inventory_management: variantData.inventory_management,
                inventory_policy: variantData.inventory_policy,
                inventory_quantity: stockValue,
                stock: stockValue,
                quantity_rule: {
                  min: quantityRule.min,
                  max: quantityRule.max,
                  increment: quantityRule.increment,
                },
              };
            } else {
              match = product.variants.find(v => v[`option${sizeIdx + 1}`] == sizeVal && v[`option${colorIdx + 1}`] == selectedColor);
            }
            if (match) {
              input.setAttribute('data-variant-id', match.id);
              if (typeof match.price !== 'undefined') input.setAttribute('data-price', match.price);
              updateQuantityLimits(input, match);
              updateStockCell(stockCell, match);
              setInventoryMeta(input, match);
              input.removeAttribute('disabled');
            } else {
              input.setAttribute('data-variant-id', '');
              input.setAttribute('data-price', '');
              updateQuantityLimits(input, null);
              updateStockCell(stockCell, null);
              setInventoryMeta(input, null);
              if ((parseInt(input.value) || 0) > 0) {
                input.value = 0;
                input.dispatchEvent(new Event('blur', { bubbles: true }));
              }
              input.setAttribute('disabled', 'disabled');
            }
          });

          try {
            if (typeof restoreTallaQuantitiesFromCart === 'function') {
              const restoreScope = picker.closest('hdt-talla-atc') || picker.closest('.hdt-group-product-block') || picker.closest('.hdt-main-product-wrap') || document;
              restoreTallaQuantitiesFromCart(restoreScope);
            }
          } catch (e) { /* noop */ }

          recalcTotals();
        };

        // Initial sync
        syncTallaForSelectedColor();
        // Expose on window for ATC preflight sync
        try {
          window.hdtTallaSync = window.hdtTallaSync || {};
          window.hdtTallaSync[productId] = { sync: syncTallaForSelectedColor };
        } catch (e) { /* noop */ }

        // React to variant changes by observing attribute updates
        let syncScheduled = false;
        const scheduleSync = () => {
          if (syncScheduled) return;
          syncScheduled = true;
          setTimeout(() => { syncScheduled = false; syncTallaForSelectedColor(); }, 0);
        };
        const mo = new MutationObserver((muts) => {
          for (const m of muts) {
            if (m.type === 'attributes') {
              if (m.attributeName === 'selected-variant' || m.attributeName === 'aria-selected' || m.attributeName === 'checked' || m.attributeName === 'value') {
                scheduleSync();
                break;
              }
            } else if (m.type === 'childList') {
              scheduleSync();
              break;
            }
          }
        });
        mo.observe(picker, { attributes: true, childList: true, subtree: true });

        // Fallback on common interaction events inside picker
        ['change','input','click'].forEach(evt => picker.addEventListener(evt, scheduleSync, true));
      }).catch(() => {});
    });
  } catch (e) {
    console.error('setupTallaVariantSync: initialization failed', e);
  }
});

// Ensure color selections scroll/filter the gallery to the matching media item
(() => {
  const pickerInitCache = new WeakSet();
  const productJsonCache = new Map();

  const fetchProductJson = (handle) => {
    if (!handle) return Promise.resolve(null);
    if (!productJsonCache.has(handle)) {
      const promise = fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
      productJsonCache.set(handle, promise);
    }
    return productJsonCache.get(handle);
  };

  const bindPicker = (picker) => {
    if (pickerInitCache.has(picker)) return;
    pickerInitCache.add(picker);

    const handle = picker.getAttribute('handle');
    if (!handle) return;

    const wrapper = picker.closest('.hdt-main-product-wrap');
    const mediaRoot = wrapper ? wrapper.querySelector('hdt-product-media') : null;
    if (!mediaRoot) return;

    fetchProductJson(handle).then((product) => {
      if (!product || !Array.isArray(product.options) || !Array.isArray(product.variants)) return;

      const optionNames = product.options.map((opt) => (typeof opt === 'string' ? opt : opt?.name || ''));
      const normalizedNames = optionNames.map((name) => (name || '').trim().toLowerCase());
      const colorIdx = normalizedNames.findIndex((name) => ['color', 'colour', 'colores'].includes(name));
      if (colorIdx === -1) return;

      const colorFieldset = picker.querySelector(`fieldset[data-index="${colorIdx}"]`);
      if (!colorFieldset) return;

      const createVariantMediaIndex = () => {
        const map = new Map();
        if (!Array.isArray(product.images)) return map;
        product.images.forEach((image) => {
          if (!image || !image.id || !Array.isArray(image.variant_ids)) return;
          const mediaId = String(image.id);
          image.variant_ids.forEach((variantId) => {
            const key = String(variantId);
            if (!map.has(key)) {
              map.set(key, new Set());
            }
            map.get(key).add(mediaId);
          });
        });
        return map;
      };

      const variantMediaIndex = createVariantMediaIndex();

      const buildColorMap = () => {
        const map = new Map();
        product.variants.forEach((variant) => {
          const colorValue = variant[`option${colorIdx + 1}`];
          if (!colorValue) return;

          const key = colorValue.trim();
          if (!map.has(key)) {
            map.set(key, { mediaIds: new Set(), variantIds: new Set() });
          }

          const entry = map.get(key);
          entry.variantIds.add(String(variant.id));
          if (variant.featured_media && variant.featured_media.id) {
            entry.mediaIds.add(String(variant.featured_media.id));
          }
          if (variant.featured_media_id) {
            entry.mediaIds.add(String(variant.featured_media_id));
          }
          const linkedMedia = variantMediaIndex.get(String(variant.id));
          if (linkedMedia) {
            linkedMedia.forEach((mediaId) => entry.mediaIds.add(mediaId));
          }
        });
        return map;
      };

      const colorLookup = buildColorMap();
      if (!colorLookup.size) return;

      const mediaItems = Array.from(mediaRoot.querySelectorAll('.hdt-product__media-item'));
      if (!mediaItems.length) return;

      let activeColor = null;
      let lastEntry = null;

      const matchesEntry = (element, entry) => {
        if (!element || !entry) return false;
        const mediaId = element.getAttribute('data-media-id');
        if (mediaId && entry.mediaIds.has(mediaId)) return true;
        const variantAttr = element.getAttribute('data-variants-id');
        if (!variantAttr) return false;
        return variantAttr.split(';').some((id) => {
          const normalized = id.trim();
          return normalized && entry.variantIds.has(normalized);
        });
      };

      const selectColorInPicker = (normalizedTarget) => {
        if (!normalizedTarget) return;

        // Try dropdown-style color pickers first
        const dropdownOption = Array.from(colorFieldset.querySelectorAll('button[role="option"]')).find((btn) => {
          const val = (btn.value || btn.getAttribute('value') || '').trim();
          return val === normalizedTarget;
        });
        if (dropdownOption) {
          dropdownOption.click();
          return;
        }

        // Fallback: radio-style color pickers
        const radio = Array.from(colorFieldset.querySelectorAll('input[is-value][type="radio"]')).find((input) => {
          return (input.value || '').trim() === normalizedTarget;
        });
        if (radio && !radio.disabled && !radio.checked) {
          radio.click();
        }
      };

      const findColorForElement = (element) => {
        if (!element) return null;
        for (const [colorValue, entry] of colorLookup.entries()) {
          if (matchesEntry(element, entry)) {
            return (colorValue || '').trim();
          }
        }
        return null;
      };

      const updateSliderUi = (entry) => {
        const visibleMedia = entry
          ? mediaItems.filter((item) => matchesEntry(item, entry))
          : mediaItems;
        const visibleCount = (visibleMedia.length || mediaItems.length);
        // Do not override [update-total] UI; preserve the theme's original total slide count.
        mediaRoot.dataset.activeColor = activeColor || '';
        mediaRoot.dataset.visibleMediaCount = String(visibleCount);
        mediaRoot.dispatchEvent(new CustomEvent('product:media:filtered', {
          bubbles: true,
          detail: {
            color: activeColor,
            visibleCount,
          },
        }));
        return { visibleMedia, visibleCount };
      };

      const applyColorFilter = (colorValue) => {
        const normalizedColor = typeof colorValue === 'string' ? colorValue.trim() : '';
        activeColor = normalizedColor;
        mediaRoot.dataset.activeColor = activeColor;

        const entry = normalizedColor ? colorLookup.get(normalizedColor) : null;
        lastEntry = entry || null;

        if (entry) {
          const firstMatch = mediaItems.find((item) => matchesEntry(item, entry));
          if (firstMatch) {
            const mediaId = firstMatch.getAttribute('data-media-id');
            if (mediaId) {
              const thumb = wrapper.querySelector(`.hdt-thumbnail__media[data-media-id="${CSS.escape(mediaId)}"]`);
              if (thumb) {
                // Synthetic click to let the native slider logic handle slide activation
                thumb.dispatchEvent(new MouseEvent('click', { bubbles: true }));
              }
            }
          }
        }

        updateSliderUi(entry || null);
      };

      const initialInput = colorFieldset.querySelector('input[is-value][type="radio"]:checked');
      if (initialInput) {
        applyColorFilter(initialInput.value);
      } else {
        applyColorFilter('');
      }

      colorFieldset.addEventListener('change', (event) => {
        const input = event.target.closest('input[is-value]');
        if (!input || input.type !== 'radio' || !input.checked) return;
        applyColorFilter(input.value);
      });

      picker.addEventListener('variant:change', (event) => {
        const variant = event.detail && event.detail.variant;
        if (!variant) return;
        const colorValue = variant[`option${colorIdx + 1}`];
        if (!colorValue) return;
        applyColorFilter(colorValue);
      });

      const syncColorFromActiveSlide = () => {
        const mainRoot = mediaRoot.querySelector('.hdt-product-media__main') || mediaRoot;
        let activeSlide = mainRoot.querySelector('.hdt-slider__slide.is-selected');
        if (!activeSlide) {
          activeSlide = mainRoot.querySelector('.hdt-slider__slide:not([hidden])');
        }
        if (!activeSlide) return;
        const normalizedTarget = findColorForElement(activeSlide);
        if (!normalizedTarget) return;
        selectColorInPicker(normalizedTarget);
      };

      // When a user clicks a thumbnail or navigates with slider buttons, sync the color option
      wrapper.addEventListener('click', (event) => {
        // Ignore synthetic clicks we create in applyColorFilter
        if (!event.isTrusted) return;
        const target = event.target;
        if (!target) return;

        const thumb = target.closest && target.closest('.hdt-thumbnail__media');
        if (thumb && wrapper.contains(thumb)) {
          const normalizedTarget = findColorForElement(thumb);
          if (!normalizedTarget) return;
          selectColorInPicker(normalizedTarget);
          return;
        }

        const navBtn = target.closest && (
          target.closest('.hdt-slider__button') ||
          target.closest('hdt-slider-counter button[name="previous"], hdt-slider-counter button[name="next"]')
        );
        if (navBtn && wrapper.contains(navBtn)) {
          // Wait for slider JS to update active slide, then sync color
          setTimeout(syncColorFromActiveSlide, 0);
        }
      });
    });
  };

  const init = (scope) => {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('hdt-variant-picker[handle][form]').forEach(bindPicker);
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

// Custom quantity button
class CustomQtyBtn extends HTMLElement {
  constructor() {
    super();
    const This = this;

    const minValue = This.querySelector("input").getAttribute("min");
    const maxValue = This.querySelector("input").getAttribute("max");

    This.querySelector("button[name=minus]").addEventListener("click", function() {
      const inputElement = This.querySelector("input");
      const currentValue = Number(inputElement.value);
      if (currentValue > minValue) {
        inputElement.value = currentValue - 1;
        inputElement.dispatchEvent(new Event("blur"));
      }
    });

    This.querySelector("button[name=plus]").addEventListener("click", function() {
      const inputElement = This.querySelector("input");
      const currentValue = Number(inputElement.value);
      if (currentValue < maxValue) {
        inputElement.value = currentValue + 1;
        inputElement.dispatchEvent(new Event("blur"));
      }
    });
  }
}

customElements.define("hdt-custom-qty-btn", CustomQtyBtn);
import { PhotoSwipeLightbox, Zoom } from "@theme/libs";
var _lightbox_psw_media_init = new WeakMap;
class CustomZoomImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const This = this;
    this.querySelector("[data-trigger-btn]").addEventListener("click", function() {
      This.dispatchEvent(new CustomEvent("lightbox:psw:open", {
        bubbles: !0,
        detail: {
          index: 0
        }
      }))

    });
    This.addEventListener("lightbox:psw:open", (t => This.openLightBox(t?.detail?.index)))
  }

  openLightBox(t = 0) {
    const e = $$4('[data-zoom-image] img', this).map((t => ({
      thumbEl: t,
      src: t.src,
      srcset: t.srcset,
      msrc: t.currentSrc || t.src,
      width: parseInt(t.getAttribute("width")),
      height: parseInt(t.getAttribute("height")),
      alt: t.alt,
      thumbCropped: !0
    })));
    this.lightBox.loadAndOpen(t, e)
  }
  get lightBox() {
    if (getterGet(_lightbox_psw_media_init, this))
      return getterGet(_lightbox_psw_media_init, this);
    let t = parseInt(this.getAttribute("max-zoom")) || 2;
    return getterAdd(_lightbox_psw_media_init, this, new PhotoSwipeLightbox({
      pswpModule: () => import("@theme/psw"),
      bgOpacity: 1,
      secondaryZoomLevel: t,
      maxZoomLevel: ++t,
      closeTitle: themeHDN.extras.pswp.close,
      zoomTitle: themeHDN.extras.pswp.zoom,
      arrowPrevTitle: themeHDN.extras.pswp.prev,
      arrowNextTitle: themeHDN.extras.pswp.next,
      errorMsg: themeHDN.extras.pswp.errorMsg
    })),
      getterGet(_lightbox_psw_media_init, this).addFilter("thumbEl", ((t, e) => e.thumbEl)),
      getterGet(_lightbox_psw_media_init, this).init(),
      getterGet(_lightbox_psw_media_init, this)
  }

}

customElements.define("hdt-custom-zoom-image", CustomZoomImage);

// Clear all size inputs functionality for collection page
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Add to Cart button states on page load
  document.querySelectorAll('.hdt-card-product__atc').forEach(function(atcButton) {
    const productId = atcButton.getAttribute('data-product-id');
    if (productId) {
      updateAtcButtonState(document, productId);
    }
  });

  // Add event listener for all clear buttons
  // document.addEventListener('click', function(event) {
  //   const clearButton = event.target.closest('.hdt-card-product__clear');
  //   if (!clearButton) return;

  //   const productId = clearButton.getAttribute('data-product-id');
  //   if (!productId) return;

  //   const groupContainer = clearButton.closest('[data-variant-group]');
  //   const variantGroup = groupContainer ? groupContainer.getAttribute('data-variant-group') : null;
  //   const colorKey = clearButton.getAttribute('data-color-key') || (groupContainer && groupContainer.getAttribute('data-color-key')) || null;

  //   let selector = `.hdt-talla-input[data-product-id='${productId}']`;
  //   if (variantGroup) selector += `[data-variant-group='${variantGroup}']`;
  //   else if (colorKey) selector += `[data-color-key='${CSS.escape(colorKey)}']`;

  //   const sizeInputs = document.querySelectorAll(selector);
  //   sizeInputs.forEach(function(input) {
  //     input.value = '0';
  //     // Use blur to run the same validation/clamp + total updates
  //     input.dispatchEvent(new Event('blur', { bubbles: true }));
  //   });

  //   // Ensure totals and ATC button states refresh
  //   updateDisplayedTotals(document, productId);
  //   updateAtcButtonState(document, productId);

  //   // Hide any previous error message for this product
  //   const errorWrapper = document.querySelector(`.hdt-form__message-wrapper[data-product-id='${productId}']`);
  //   if (errorWrapper) errorWrapper.hidden = true;
  // });

  // Prevent cart drawer from opening on collection pages but allow cart count updates
  document.addEventListener('variant:add', function(event) {
    if (event.detail && event.detail.preventCartDrawer) {
      // Update cart count manually
      const cartCountElements = document.querySelectorAll('hdt-cart-count');
      if (event.detail.cart && event.detail.cart.item_count !== undefined) {
        cartCountElements.forEach(function(element) {
          element.textContent = event.detail.cart.item_count;
        });
      }

      // Update cart drawer contents without opening it
      const cartDrawer = document.querySelector('hdt-cart-drawer');
      if (cartDrawer && event.detail.cart) {
        // Try multiple methods to update cart drawer content
        if (typeof cartDrawer.updateCartContents === 'function') {
          cartDrawer.updateCartContents(event.detail.cart);
        } else if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(event.detail.cart);
        } else if (typeof cartDrawer.updateCart === 'function') {
          cartDrawer.updateCart(event.detail.cart);
        } else {
          // Fallback: fetch and update cart drawer sections
          if (event.detail.cart.sections) {
            const cartDrawerSection = event.detail.cart.sections['cart-drawer'];
            if (cartDrawerSection) {
              const parser = new DOMParser();
              const newDoc = parser.parseFromString(cartDrawerSection, 'text/html');
              const newCartContent = newDoc.querySelector('hdt-cart-drawer');
              if (newCartContent && cartDrawer) {
                // Cập nhật an toàn: giữ nguyên element dialog hiện tại để tránh detach
                const existingDialog = cartDrawer.querySelector('#CartDrawer') || cartDrawer.querySelector('dialog');
                const newDialog = newCartContent.querySelector('#CartDrawer') || newCartContent.querySelector('dialog');
                if (existingDialog && newDialog) {
                  existingDialog.innerHTML = newDialog.innerHTML;
                } else if (existingDialog) {
                  existingDialog.innerHTML = newCartContent.innerHTML;
                } else {
                  cartDrawer.innerHTML = newCartContent.innerHTML;
                }
              }
            }
          }
        }
      }

      // Stop the event from reaching the cart drawer to prevent it from opening
      event.stopImmediatePropagation();
    }
  }, true); // Use capture phase to intercept before other listeners

  document.addEventListener('cart:change', function(event) {
    if (event.detail && event.detail.preventCartDrawer) {
      // Update cart count manually for cart:change events too
      const cartCountElements = document.querySelectorAll('hdt-cart-count');
      if (event.detail.cart && event.detail.cart.item_count !== undefined) {
        cartCountElements.forEach(function(element) {
          element.textContent = event.detail.cart.item_count;
        });
      }

      // Update cart drawer contents without opening it
      const cartDrawer = document.querySelector('hdt-cart-drawer');
      if (cartDrawer && event.detail.cart) {
        // Try multiple methods to update cart drawer content
        if (typeof cartDrawer.updateCartContents === 'function') {
          cartDrawer.updateCartContents(event.detail.cart);
        } else if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(event.detail.cart);
        } else if (typeof cartDrawer.updateCart === 'function') {
          cartDrawer.updateCart(event.detail.cart);
        } else {
          // Fallback: fetch and update cart drawer sections
          if (event.detail.cart.sections) {
            const cartDrawerSection = event.detail.cart.sections['cart-drawer'];
            if (cartDrawerSection) {
              const parser = new DOMParser();
              const newDoc = parser.parseFromString(cartDrawerSection, 'text/html');
              const newCartContent = newDoc.querySelector('hdt-cart-drawer');
              if (newCartContent && cartDrawer) {
                // Cập nhật an toàn: giữ nguyên element dialog hiện tại để tránh detach
                const existingDialog = cartDrawer.querySelector('#CartDrawer') || cartDrawer.querySelector('dialog');
                const newDialog = newCartContent.querySelector('#CartDrawer') || newCartContent.querySelector('dialog');
                if (existingDialog && newDialog) {
                  existingDialog.innerHTML = newDialog.innerHTML;
                } else if (existingDialog) {
                  existingDialog.innerHTML = newCartContent.innerHTML;
                } else {
                  cartDrawer.innerHTML = newCartContent.innerHTML;
                }
              }
            }
          }
        }
      }

      // Stop the event from reaching the cart drawer
      event.stopImmediatePropagation();
    }
  }, true); // Use capture phase to intercept before other listeners
});